import { Component, EventEmitter, HostListener, Inject, Injectable, Input, NgModule, Output, ViewChild } from '@angular/core';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Headers, Http, HttpModule, ResponseContentType } from '@angular/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subject } from 'rxjs/Subject';
import { Feature, Geolocation, Map, Observable, View, control, events, extent, format, interaction, layer, loadingstrategy, proj, source, style } from 'openlayers';
import * as ol from 'openlayers';
import { parseString } from 'xml2js';
import * as xml2js from 'xml2js';
import 'rxjs/Rx';
import { chain, find, keys, max, mean, min, reverse, uniqBy } from 'lodash';
import * as _ from 'lodash';
import { Observable as Observable$1 } from 'rxjs/Observable';
import ol_layer_AnimatedCluster from 'ol-ext/layer/AnimatedCluster';
import { isNullOrUndefined } from 'util';
import { Cookie } from 'ng2-cookies/index';

var Dispatcher = (function () {
    function Dispatcher() {
        this.observable = new Subject();
    }
    /**
     * @param {?} payload
     * @return {?}
     */
    Dispatcher.prototype.dispatch = function (payload) {
        this.observable.next(payload);
    };
    return Dispatcher;
}());
Dispatcher.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
Dispatcher.ctorParameters = function () { return []; };

/**
 * Dispatches the actions to the mapStore.
This class is injected in all components who need mapActions.
\@export
\@class MapActions
 */
var MapActions = (function () {
    /**
     * @param {?} dispatcher
     */
    function MapActions(dispatcher) {
        this.dispatcher = dispatcher;
    }
    /**
     * @param {?} olInteraction
     * @return {?}
     */
    MapActions.prototype.addInteraction = function (olInteraction) {
        this.dispatcher.dispatch({
            type: ActionType.ADD_INTERACTION,
            body: olInteraction
        });
    };
    /**
     * @param {?} olLayer
     * @return {?}
     */
    MapActions.prototype.addLayer = function (olLayer) {
        this.dispatcher.dispatch({
            type: ActionType.ADD_LAYER,
            body: olLayer
        });
    };
    /**
     * @param {?} olInteraction
     * @return {?}
     */
    MapActions.prototype.removeInteraction = function (olInteraction) {
        this.dispatcher.dispatch({
            type: ActionType.REMOVE_INTERACTION,
            body: olInteraction
        });
    };
    /**
     * @param {?} olLayer
     * @return {?}
     */
    MapActions.prototype.removeLayer = function (olLayer) {
        this.dispatcher.dispatch({
            type: ActionType.REMOVE_LAYER,
            body: olLayer
        });
    };
    /**
     * @param {?} map
     * @return {?}
     */
    MapActions.prototype.setMap = function (map) {
        this.dispatcher.dispatch({
            type: ActionType.SET_MAP,
            body: map
        });
    };
    /**
     * @param {?} projection
     * @return {?}
     */
    MapActions.prototype.setProjection = function (projection) {
        this.dispatcher.dispatch({
            type: ActionType.SET_PROJECTION,
            body: projection
        });
    };
    /**
     * @param {?} olLayer
     * @return {?}
     */
    MapActions.prototype.updateLayer = function (olLayer) {
        this.dispatcher.dispatch({
            type: ActionType.UPDATE_LAYER,
            body: olLayer
        });
    };
    /**
     * @param {?} olLayer
     * @return {?}
     */
    MapActions.prototype.addHistory = function (olLayer) {
        this.dispatcher.dispatch({
            type: ActionType.ADD_HISTORY,
            body: olLayer
        });
    };
    /**
     * @param {?} layerId
     * @param {?} time
     * @return {?}
     */
    MapActions.prototype.updateLayerTime = function (layerId, time) {
        this.dispatcher.dispatch({
            type: ActionType.UPDATE_LAYER_TIME,
            body: { layerId: layerId, time: time }
        });
    };
    return MapActions;
}());
MapActions.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
MapActions.ctorParameters = function () { return [
    { type: Dispatcher, },
]; };
var ActionType = {};
ActionType.ADD_INTERACTION = 0;
ActionType.ADD_LAYER = 1;
ActionType.REMOVE_INTERACTION = 2;
ActionType.REMOVE_LAYER = 3;
ActionType.SET_MAP = 4;
ActionType.SET_PROJECTION = 5;
ActionType.UPDATE_LAYER = 6;
ActionType.ADD_HISTORY = 7;
ActionType.UPDATE_LAYER_TIME = 8;
ActionType[ActionType.ADD_INTERACTION] = "ADD_INTERACTION";
ActionType[ActionType.ADD_LAYER] = "ADD_LAYER";
ActionType[ActionType.REMOVE_INTERACTION] = "REMOVE_INTERACTION";
ActionType[ActionType.REMOVE_LAYER] = "REMOVE_LAYER";
ActionType[ActionType.SET_MAP] = "SET_MAP";
ActionType[ActionType.SET_PROJECTION] = "SET_PROJECTION";
ActionType[ActionType.UPDATE_LAYER] = "UPDATE_LAYER";
ActionType[ActionType.ADD_HISTORY] = "ADD_HISTORY";
ActionType[ActionType.UPDATE_LAYER_TIME] = "UPDATE_LAYER_TIME";

// third party libraries
var CapabilitiesService = (function () {
    /**
     * @param {?} http
     */
    function CapabilitiesService(http) {
        this.http = http;
    }
    /**
     * @param {?} json
     * @return {?}
     */
    CapabilitiesService.prototype.getAllLayers = function (json) {
        var /** @type {?} */ layers = [];
        var /** @type {?} */ layer$$1 = json['Capability'] ? json['Capability']['Layer'] : json['Contents'] ? json['Contents'] : [];
        var /** @type {?} */ tmpLayers = [layer$$1];
        for (var /** @type {?} */ i = 0; i < tmpLayers.length; i++) {
            tmpLayers = tmpLayers.concat(this.getLayers(tmpLayers[i]));
            layers.push(tmpLayers[i]);
        }
        return layers;
    };
    /**
     * @param {?} layer
     * @return {?}
     */
    CapabilitiesService.prototype.getCapabilities = function (layer$$1) {
        var /** @type {?} */ url;
        if (layer$$1.getSource() instanceof source.ImageWMS) {
            url = ((layer$$1.getSource())).getUrl();
        }
        else {
            url = ((layer$$1.getSource())).getUrls()[0];
        }
        if (url.slice(-1) === '?') {
            url = url.slice(0, -1);
        }
        url += "?service=" + ((layer$$1.getSource() instanceof source.ImageWMS || layer$$1.getSource() instanceof source.TileWMS) ? 'WMS'
            : layer$$1.getSource() instanceof source.WMTS ? 'WMTS' : 'WFS') + "&request=getCapabilities";
        return this.http.get(url).map(function (response) {
            if (layer$$1.getSource() instanceof source.ImageWMS || layer$$1.getSource() instanceof source.TileWMS) {
                var /** @type {?} */ wmsFormat = new format.WMSCapabilities();
                return wmsFormat.read(response.text());
            }
            else if (layer$$1.getSource() instanceof source.WMTS) {
                var /** @type {?} */ wmtsFormat = new format.WMTSCapabilities();
                return wmtsFormat.read(response.text());
            }
            else if (layer$$1.getSource() instanceof source.Vector) {
                return parseString(response.text());
            }
        });
    };
    /**
     * @param {?} layerId
     * @param {?} capabilities
     * @return {?}
     */
    CapabilitiesService.prototype.getExtent = function (layerId, capabilities) {
        var /** @type {?} */ layers = this.getAllLayers(capabilities);
        var /** @type {?} */ extent$$1 = [];
        layers.forEach(function (layer$$1) {
            if (layer$$1['Name'] && layer$$1['Name'] === layerId) {
                extent$$1 = layer$$1['EX_GeographicBoundingBox'];
            }
        });
        return extent$$1;
    };
    /**
     * @param {?} layer
     * @param {?} params
     * @param {?} format
     * @return {?}
     */
    CapabilitiesService.prototype.getFeatureInfo = function (layer$$1, params, format$$1) {
        var /** @type {?} */ url = "" + layer$$1.source.url;
        if (layer$$1.source.type === 'WMS') {
            url += "?service=wms&request=GetFeatureInfo&version=1.0.0&srs=epsg:3857";
            url += "&layers=" + layer$$1.source.params.LAYERS + "&query_layers=" + layer$$1.source.params.LAYERS;
            url += "&bbox=" + params.extent + "&width=" + params.size[0] + "&height=" + params.size[1] + "&x=" + params.pixel[0] + "&y=" + params.pixel[1];
            url += "&info_format=" + format$$1;
        }
        else if (layer$$1.source.type === 'WFS') {
            var /** @type {?} */ extent$$1 = [params.coordinates[0], params.coordinates[1], params.coordinates[0], params.coordinates[1]];
            url += "?service=wfs&request=GetFeature&version=1.1.0&bbox=" + extent$$1;
            url += "&typename=" + layer$$1.source.layer + "&srcname=" + layer$$1.source.projection + "&outputFormat=" + format$$1;
        }
        else if (layer$$1.source.type === 'WMTS') {
            var /** @type {?} */ tileResolutions = layer$$1.source.getTileGrid().getResolutions();
            var /** @type {?} */ zoomIdx_1, /** @type {?} */ diff_1 = Infinity;
            tileResolutions.forEach(function (tileResolution, index) {
                var /** @type {?} */ diffP = Math.abs(params.resolution - tileResolution);
                if (diffP < diff_1) {
                    diff_1 = diffP;
                    zoomIdx_1 = index;
                }
                if (tileResolution < params.resolution) {
                    return;
                }
            });
            var /** @type {?} */ tileSize = layer$$1.source.getTileGrid().getTileSize(zoomIdx_1);
            var /** @type {?} */ tileOrigin = layer$$1.source.getTileGrid().getOrigin(zoomIdx_1);
            var /** @type {?} */ fx = (params.coordinates[0] - tileOrigin[0]) / (params.resolution * tileSize);
            var /** @type {?} */ fy = (tileOrigin[1] - params.coordinates[1]) / (params.resolution * tileSize);
            var /** @type {?} */ tileCol = Math.floor(fx);
            var /** @type {?} */ tileRow = Math.floor(fy);
            var /** @type {?} */ tileI = Math.floor((fx - tileCol) * tileSize);
            var /** @type {?} */ tileJ = Math.floor((fy - tileRow) * tileSize);
            var /** @type {?} */ matrixId = layer$$1.source.getTileGrid().getMatrixIds()[zoomIdx_1];
            url += "?service=wmts&request=GetFeatureInfo&version=1.0.0";
            url += "&layer=" + layer$$1.source.layer + "&style=default&format=image/png&tileMatrixSet=" + layer$$1.source.matrixSet;
            url += "&tileMatrix=" + matrixId + "&tileRow=" + tileRow + "&tileCol=" + tileCol + "&i=" + tileI + "&j=" + tileJ;
            url += "infoFormat=" + format$$1;
        }
        return this.http.get(url).map(function (response) { return response.json(); });
    };
    /**
     * @param {?} layer
     * @param {?} capa
     * @return {?}
     */
    CapabilitiesService.prototype.getFeatureInfoFormat = function (layer$$1, capa) {
        if (layer$$1.source.type === 'WMS' || layer$$1.source.type === 'WMTS') {
            if (capa['Capability'] && capa['Capability']['Request'] && capa['Capability']['Request']['GetFeatureInfo']) {
                return capa['Capability']['Request']['GetFeatureInfo']['Format'];
            }
            else {
                return null;
            }
        }
        else if (layer$$1.source.type === 'WFS') {
            var /** @type {?} */ operations = capa['wfs:WFS_Capabilities']['ows:OperationsMetadata'][0]['ows:Operation'];
            var /** @type {?} */ getFeatureOperation = operations.filter(function (operation) { return operation['$'].name === 'GetFeature'; }).pop();
            if (getFeatureOperation) {
                var /** @type {?} */ parameters = getFeatureOperation['ows:Parameter'];
                var /** @type {?} */ outputFormatParameter = parameters.filter(function (parameter) { return parameter['$'].name === 'outputFormat'; }).pop();
                return outputFormatParameter['ows:AllowedValues'][0]['ows:Value'];
            }
        }
        return null;
    };
    /**
     * @param {?} layer
     * @return {?}
     */
    CapabilitiesService.prototype.getLayers = function (layer$$1) {
        var /** @type {?} */ l = layer$$1.Layer;
        if (!l) {
            return [];
        }
        else if (l.constructor && l.constructor === Array) {
            return l;
        }
        else {
            return [l];
        }
    };
    return CapabilitiesService;
}());
CapabilitiesService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
CapabilitiesService.ctorParameters = function () { return [
    { type: Http, },
]; };

/**
 * Creates & maintains the current state.
\@export
\@class MapStore
\@property {Observable<State>} state Contains all layers & interactions
 */
var MapStore = (function () {
    /**
     * Creates an instance of MapStore.
    Subscribes to the dispatcher & handles the actions.
    \@param {Dispatcher} dispatcher
    \@param {CapabilitiesService} capabilitiesService
    \@memberof MapStore
     * @param {?} dispatcher
     * @param {?} capabilitiesService
     */
    function MapStore(dispatcher, capabilitiesService) {
        var _this = this;
        this.dispatcher = dispatcher;
        this.capabilitiesService = capabilitiesService;
        this.dataStore = { projection: '', map: null };
        this._state = new BehaviorSubject({ layers: [], interactions: [] });
        this.state = this._state.asObservable();
        this.dispatcher.observable.subscribe(function (payload) {
            switch (payload.type) {
                case ActionType.SET_MAP:
                    _this.setMap(payload.body);
                    break;
                case ActionType.SET_PROJECTION:
                    _this.setProjection(payload.body);
                    break;
                case ActionType.ADD_LAYER:
                    _this._state.next(_this.addLayer(payload.body));
                    break;
                case ActionType.REMOVE_LAYER:
                    _this._state.next(_this.removeLayer(payload.body));
                    break;
                case ActionType.UPDATE_LAYER:
                    _this._state.next(_this.updateLayer(payload.body));
                    break;
                case ActionType.ADD_INTERACTION:
                    _this._state.next(_this.addInteraction(payload.body));
                    break;
                case ActionType.REMOVE_INTERACTION:
                    _this._state.next(_this.removeInteraction(payload.body));
                    break;
                case ActionType.ADD_HISTORY:
                    _this.addHistory(payload.body).subscribe(function (times) {
                        var stateLayer = _this._state.value.layers.find(function (layer$$1) { return layer$$1.get('id') === payload.body.get('id'); });
                        if (stateLayer && times && times.length) {
                            // Filter out incorrect ISO-strings
                            times = times.filter(function (date) { return date.string.match(/.*[T]([0-9]{2}:){2}([0-9]{2}\.)[0-9]{3}.*/); });
                            // Make sure date/time is unique
                            times = uniqBy(times, 'date');
                            // Make sure data is unique (keep latest)
                            var reversed = reverse(times); // Reverse to keep latest
                            var uniqDate = uniqBy(reversed, function (date) {
                                return date.string.split('T')[0]; // Get Date part of ISO-string;
                            });
                            times = reverse(uniqDate); // Reverse again to get correct order.
                            stateLayer.set('vitojs_history', times);
                        }
                        _this._state.next(_this._state.value);
                    });
                    break;
                case ActionType.UPDATE_LAYER_TIME:
                    _this._state.next(_this.updateLayerTime(payload.body));
                    break;
            }
        });
    }
    /**
     * Adds an interaction to the state.
    \@private
    \@param {ol.interaction.Interaction} olInteraction
    \@returns {State}
    \@memberof MapStore
     * @param {?} olInteraction
     * @return {?}
     */
    MapStore.prototype.addInteraction = function (olInteraction) {
        this._state.value.interactions.push(olInteraction);
        return this._state.value;
    };
    /**
     * Adds a layer to the state.
    \@private
    \@param {ol.layer.Layer} olLayer
    \@returns {State}
    \@memberof MapStore
     * @param {?} olLayer
     * @return {?}
     */
    MapStore.prototype.addLayer = function (olLayer) {
        this._state.value.layers.push(olLayer);
        return this._state.value;
    };
    /**
     * Returns the ol.Map object.
    \@returns {ol.Map} The current Map object
    \@memberof MapStore
     * @return {?}
     */
    MapStore.prototype.getMap = function () {
        return this.dataStore.map;
    };
    /**
     * Returns the projection of the Map object.
    \@returns {string} The current projection of the map
    \@memberof MapStore
     * @return {?}
     */
    MapStore.prototype.getProjection = function () {
        return this.dataStore.projection;
    };
    /**
     * Removes an interaction from the state.
    \@private
    \@param {ol.interaction.Interaction} olInteraction
    \@returns {State}
    \@memberof MapStore
     * @param {?} olInteraction
     * @return {?}
     */
    MapStore.prototype.removeInteraction = function (olInteraction) {
        this._state.value.interactions = this._state.value.interactions.filter(function (interaction$$1) { return interaction$$1.get('id') !== olInteraction.get('id'); });
        return this._state.value;
    };
    /**
     * Removes a layer from the state.
    \@private
    \@param {ol.layer.Layer} olLayer
    \@returns {State}
    \@memberof MapStore
     * @param {?} olLayer
     * @return {?}
     */
    MapStore.prototype.removeLayer = function (olLayer) {
        this._state.value.layers = this._state.value.layers.filter(function (layer$$1) { return layer$$1.get('id') !== olLayer.get('id'); });
        return this._state.value;
    };
    /**
     * Set a new map object to the dataStore.
    \@private
    \@param {ol.Map} map
    \@memberof MapStore
     * @param {?} map
     * @return {?}
     */
    MapStore.prototype.setMap = function (map) {
        this.dataStore.map = map;
    };
    /**
     * Set a new projection to the dataStore.
    \@private
    \@param {string} projection
    \@memberof MapStore
     * @param {?} projection
     * @return {?}
     */
    MapStore.prototype.setProjection = function (projection) {
        this.dataStore.projection = projection;
    };
    /**
     * Updates a layer in the state.
    \@private
    \@param {ol.layer.Layer} olLayer
    \@returns
    \@memberof MapStore
     * @param {?} olLayer
     * @return {?}
     */
    MapStore.prototype.updateLayer = function (olLayer) {
        var /** @type {?} */ index = this._state.value.layers.findIndex(function (layer$$1) { return layer$$1.get('id') === olLayer.get('id'); });
        this._state.value.layers[index] = olLayer;
        return this._state.value;
    };
    /**
     * Reads the possible times from a GetCapabilities reques for a given
    Layer and returns them.
    \@private
    \@param {ol.layer.Layer} olLayer
    \@returns {Observable<{string: string, date: Date}[]>}
    \@memberof MapStore
     * @param {?} olLayer
     * @return {?}
     */
    MapStore.prototype.addHistory = function (olLayer) {
        var _this = this;
        return this.capabilitiesService.getCapabilities(olLayer).map(function (capa) {
            var /** @type {?} */ layers = _this.capabilitiesService.getAllLayers(capa);
            var /** @type {?} */ layer_ = null;
            var /** @type {?} */ timeDimension = null;
            var /** @type {?} */ timeStrings = [];
            if (olLayer.getSource() instanceof source.ImageWMS || olLayer.getSource() instanceof source.TileWMS) {
                layer_ = layers.filter(function (layer$$1) { return layer$$1['Name'] === olLayer.getSource().getParams()['LAYERS']; }).pop();
                if (layer_) {
                    timeDimension = layer_['Dimension'].filter(function (dimension) { return dimension.name.toUpperCase() === 'TIME'; }).pop();
                    timeStrings = timeDimension.values.split(',');
                }
            }
            else if (olLayer.getSource() instanceof source.WMTS) {
                layer_ = layers.filter(function (layer$$1) { return layer$$1['Identifier'] === olLayer.getSource().getLayer(); }).pop();
                /*
                     Bug #502 of Geowebcache (https://github.com/GeoWebCache/geowebcache/issues/520): Incorrect namespace is included in the dimensions
                     of a layer configuration.This results in an incorrect capabilities that does not include dimension identifier.

                     Impact: Look for missing identifier
                 */
                timeDimension = layer_['Dimension'].filter(function (dimension) {
                    if (dimension['Identifier']) {
                        if (dimension['Identifier'].toUpperCase() === 'TIME') {
                            return true;
                        }
                    }
                    else {
                        return true;
                    }
                }).pop();
                timeStrings = timeDimension['Value'];
            }
            var /** @type {?} */ times = timeStrings.map(function (timeString) {
                return { string: String(timeString), date: new Date(timeString) };
            });
            times.sort(function (time1, time2) { return time1.date.getTime() - time2.date.getTime(); });
            return times;
        });
    };
    /**
     * Updates the time on a layer, then updates the layer in the state.
    \@private
    \@param {*} {layerId, time}
    \@returns {State}
    \@memberof MapStore
     * @param {?} __0
     * @return {?}
     */
    MapStore.prototype.updateLayerTime = function (_a) {
        var layerId = _a.layerId, time = _a.time;
        var /** @type {?} */ index = this._state.value.layers.findIndex(function (layer$$1) { return layer$$1.get('id') === layerId; });
        var /** @type {?} */ olLayer = this._state.value.layers[index];
        if (olLayer.getSource() instanceof source.ImageWMS || olLayer.getSource() instanceof source.TileWMS) {
            var /** @type {?} */ params = ((olLayer.getSource())).getParams();
            params['TIME'] = time;
            ((olLayer.getSource())).updateParams(params);
        }
        else if (olLayer.getSource() instanceof source.WMTS) {
            var /** @type {?} */ dimensions = ((olLayer.getSource())).getDimensions();
            ((dimensions)).TIME = time;
            ((olLayer.getSource())).updateDimensions(dimensions);
        }
        return this.updateLayer(olLayer);
    };
    return MapStore;
}());
MapStore.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
MapStore.ctorParameters = function () { return [
    { type: Dispatcher, },
    { type: CapabilitiesService, },
]; };

/**
 * Creates an ol.Map and changes the view.
\@export
\@class OlMapService
\@property {BehaviorSubject<ol.Map>} map Subscribing to this property gives the ol.Map object.
 */
var OlMapService = (function () {
    function OlMapService() {
        this.map = new BehaviorSubject(undefined);
    }
    /**
     * Creates an ol Map object.
    \@param {ol.Extent} extent The boundaries of the part of the map which will be displayed.
    \@param {string} projection The projection. Default is EPSG:3857 (Spherical Mercator).
    \@param {boolean} fixedExtent The extent that constrains the center, in other words, center cannot be set outside this extent. Only when fixedExtent is true.
    \@returns {ol.Map} The openlayers Map object
    \@memberof OlMapService
     * @param {?} extent
     * @param {?} projection
     * @param {?} fixedExtent
     * @param {?=} control
     * @param {?=} interactions
     * @return {?}
     */
    OlMapService.prototype.createMap = function (extent$$1, projection, fixedExtent, control$$1, interactions) {
        if (!extent$$1 || !projection) {
            console.error('VitoJS: Creation of map failed. A map must have an extent and a projection.');
            return;
        }
        var /** @type {?} */ map = new Map({
            target: 'map',
            interactions: interactions ? interaction.defaults(interactions) : interaction.defaults(),
            controls: control$$1 ? control.defaults(control$$1) : control.defaults({
                attribution: false,
                rotate: false
            }).extend([
                new control.ScaleLine(),
                this.getZoomToExtent(proj.transformExtent(extent$$1, 'EPSG:4326', projection))
            ])
        });
        this.setExtent(extent$$1, projection, fixedExtent, map);
        this.map.next(map);
        return map;
    };
    /**
     * Creates a 'zoomToExtent' control. Used by createMap.
    \@param {*} extent
    \@returns {ol.control.ZoomToExtent}
    \@memberof OlMapService
     * @param {?} extent
     * @return {?}
     */
    OlMapService.prototype.getZoomToExtent = function (extent$$1) {
        var /** @type {?} */ olControl = new control.ZoomToExtent({
            extent: extent$$1
        });
        olControl.set('id', 'zoomToExtent');
        return olControl;
    };
    /**
     * Set the view to a new extent, or a new fixedExtent.
    \@param {ol.Extent} newExtent
    \@param {string} projection
    \@param {boolean} fixedExtent
    \@param {ol.Map} map
    \@memberof OlMapService
     * @param {?} newExtent
     * @param {?} projection
     * @param {?} fixedExtent
     * @param {?} map
     * @return {?}
     */
    OlMapService.prototype.setExtent = function (newExtent, projection, fixedExtent, map) {
        var _this = this;
        map.setView(new View({
            projection: projection,
        }));
        if (fixedExtent) {
            var /** @type {?} */ v = map.getView();
            newExtent = this.fitExtent(newExtent, projection, map);
            map.setView(new View({
                projection: projection,
                center: v.getCenter(),
                zoom: v.getZoom(),
                extent: v.calculateExtent(map.getSize()),
                minZoom: v.getZoom(),
                maxZoom: 28
            }));
        }
        else {
            newExtent = this.fitExtent(newExtent, projection, map);
        }
        map.getControls().getArray().forEach(function (olControl) {
            if (olControl.get('id') === 'zoomToExtent') {
                map.removeControl(olControl);
                map.addControl(_this.getZoomToExtent(newExtent));
            }
        });
    };
    /**
     * @param {?} extent
     * @param {?} projection
     * @param {?} map
     * @return {?}
     */
    OlMapService.prototype.fitExtent = function (extent$$1, projection, map) {
        var /** @type {?} */ newExtent = proj.transformExtent(extent$$1, 'EPSG:4326', projection);
        map.getView().fit(newExtent, { size: map.getSize() });
        return newExtent;
    };
    return OlMapService;
}());
OlMapService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
OlMapService.ctorParameters = function () { return []; };

/**
 * A component which can be used to create an ol.Map.
Always needed when using layer & interaction components.
\@export
\@class MapComponent
\@property {ol.Extent} extent The boundaries of the part of the map which will be displayed.
\@property {ol.Extent} boundingExtent The extent that constrains the center, in other words, center cannot be set outside this extent. Only when fixedExtent is true.
\@property {string} projection The projection. Default is EPSG:3857 (Spherical Mercator).
\@property {boolean} fixedExtent Determines whether the extent is fixed or not. Used with boundingExtent.
\@property {boolean} keyboardControllable
\@property {EventEmitter<boolean>} onLoad Emits true when layers are loading, false if ready.
\@property {EventEmitter<ol.MapEvent>} moveend Emits event when stopped moving the map.
\@implements {OnInit}
\@implements {OnChanges}
 */
var MapComponent = (function () {
    /**
     * @param {?} mapStore
     * @param {?} actions
     * @param {?} olMap
     */
    function MapComponent(mapStore, actions, olMap) {
        this.mapStore = mapStore;
        this.actions = actions;
        this.olMap = olMap;
        this.fixedExtent = false;
        this.keyboardControllable = false;
        this.onLoad = new EventEmitter();
        this.moveend = new EventEmitter();
        this.loadCount = 0;
    }
    /**
     * Retrieves ol.Map object from olMapService, then adds it to the mapStore.
    Also adds projection to mapStore, and subscribe to store to
    update the layers when needed.
    \@returns
    \@memberof MapComponent
     * @return {?}
     */
    MapComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.map = this.olMap.createMap(this.boundingExtent, this.projection, this.fixedExtent, this.control, this.interactions);
        if (!this.map) {
            return;
        }
        this.map.on('moveend', function (event) {
            _this.moveend.emit(event);
        });
        this.actions.setMap(this.map);
        this.actions.setProjection(this.projection);
        if (this.extent) {
            this.olMap.fitExtent(this.extent, this.projection, this.map);
        }
        this.mapStore.state.subscribe(function (newState) {
            _this.updateLayers(newState.layers);
            _this.updateInteractions(newState.interactions);
        });
    };
    /**
     * Sets changes to extent/boundingExtent to the ol.Map
    \@param {SimpleChanges} changes
    \@memberof MapComponent
     * @param {?} changes
     * @return {?}
     */
    MapComponent.prototype.ngOnChanges = function (changes) {
        if (this.map) {
            if (changes.boundingExtent) {
                if (!this.compareArrays(changes.boundingExtent.previousValue, changes.boundingExtent.currentValue)) {
                    this.olMap.setExtent(this.boundingExtent, this.projection, this.fixedExtent, this.map);
                }
            }
            if (changes.extent) {
                if (!this.compareArrays(changes.extent.previousValue, changes.extent.currentValue)) {
                    this.olMap.fitExtent(this.extent, this.projection, this.map);
                }
            }
        }
    };
    /**
     * Synchronizes the interactions from the mapStore and the ol.Map
    \@param {any} olInteractions
    \@memberof MapComponent
     * @param {?} olInteractions
     * @return {?}
     */
    MapComponent.prototype.updateInteractions = function (olInteractions) {
        var _this = this;
        var /** @type {?} */ currentInteractions = this.map.getInteractions().getArray();
        var /** @type {?} */ index = null;
        olInteractions.forEach(function (olInteraction) {
            index = currentInteractions.findIndex(function (interaction$$1) { return interaction$$1.get('id') === olInteraction.get('id'); });
            if (index < 0) {
                _this.map.addInteraction(olInteraction);
            }
            else {
                currentInteractions[index] = olInteraction;
            }
        });
        currentInteractions.forEach(function (interaction$$1) {
            if (interaction$$1.get('id')) {
                index = olInteractions.findIndex(function (olInteraction) { return olInteraction.get('id') === interaction$$1.get('id'); });
                if (index < 0) {
                    _this.map.removeInteraction(interaction$$1);
                }
            }
        });
    };
    /**
     * Synchronizes the layers from the mapStore and the ol.Map.
    Also adds listeners to load events to determine the value of load emitter
    \@param {any} olLayers
    \@memberof MapComponent
     * @param {?} olLayers
     * @return {?}
     */
    MapComponent.prototype.updateLayers = function (olLayers) {
        var _this = this;
        this.loadCount = 0;
        var /** @type {?} */ currentLayers = this.map.getLayers().getArray();
        var /** @type {?} */ index = null;
        olLayers.forEach(function (olLayer) {
            index = currentLayers.findIndex(function (layer$$1) { return layer$$1.get('id') === olLayer.get('id'); });
            if (index < 0) {
                _this.map.addLayer(olLayer);
                olLayer.getSource().on('tileloadend', function (event) { return _this.setLoading(false); });
                olLayer.getSource().on('imageloadend', function (event) { return _this.setLoading(false); });
                olLayer.getSource().on('imageloaderror', function (event) { return _this.setLoading(false); });
                olLayer.getSource().on('tileloaderror', function (event) { return _this.setLoading(false); });
                olLayer.getSource().on('tileloadstart', function (event) { return _this.setLoading(true); });
                olLayer.getSource().on('imageloadstart', function (event) { return _this.setLoading(true); });
                olLayer.getSource().on('vectorloadstart', function (event) { return _this.setLoading(true); });
                olLayer.getSource().on('vectorloadend', function (event) { return _this.setLoading(false); });
                olLayer.getSource().on('vectorloaderror', function (event) { return _this.setLoading(false); });
            }
            else {
                currentLayers[index] = olLayer;
            }
        });
        currentLayers.forEach(function (layer$$1) {
            index = olLayers.findIndex(function (olLayer) { return olLayer.get('id') === layer$$1.get('id'); });
            if (index < 0) {
                try {
                    _this.map.removeLayer(layer$$1);
                }
                catch (e) {
                    layer$$1.setVisible(false);
                }
            }
        });
    };
    /**
     * @param {?} up
     * @return {?}
     */
    MapComponent.prototype.setLoading = function (up) {
        if (up) {
            if (this.loadCount === 0) {
                this.onLoad.emit(true);
            }
            this.loadCount++;
        }
        else {
            this.loadCount--;
            if (this.loadCount <= 0) {
                this.loadCount = 0;
                this.onLoad.emit(false);
            }
        }
    };
    /**
     * @param {?} arr1
     * @param {?} arr2
     * @return {?}
     */
    MapComponent.prototype.compareArrays = function (arr1, arr2) {
        var /** @type {?} */ same = true;
        arr1.forEach(function (el, idx) {
            if (!same) {
                return;
            }
            if (el !== arr2[idx]) {
                same = false;
            }
        });
        return same;
    };
    return MapComponent;
}());
MapComponent.decorators = [
    { type: Component, args: [{
                selector: 'vito-map',
                template: '<div id="map" [attr.tabindex]="keyboardControllable ? 0: null"></div><ng-content></ng-content>',
                styles: ["\n        :host {\n            display: block;\n            height: 100%;\n            width: 100%;\n        }\n\n        #map {\n            height: inherit;\n            width: inherit;\n        }\n\n        #map:focus {\n            outline: none;\n        }\n    "]
            },] },
];
/**
 * @nocollapse
 */
MapComponent.ctorParameters = function () { return [
    { type: MapStore, },
    { type: MapActions, },
    { type: OlMapService, },
]; };
MapComponent.propDecorators = {
    'extent': [{ type: Input },],
    'boundingExtent': [{ type: Input },],
    'projection': [{ type: Input },],
    'fixedExtent': [{ type: Input },],
    'keyboardControllable': [{ type: Input },],
    'control': [{ type: Input },],
    'interactions': [{ type: Input },],
    'onLoad': [{ type: Output },],
    'moveend': [{ type: Output },],
};

/**
 * Converts a style config file to an ol.StyleFunction.
Config file is just an object with all the parameters for the
different style objects.
\@export
\@class OlStyleService
 */
var OlStyleService = (function () {
    function OlStyleService() {
    }
    /**
     * Main method that converts styleObject to ol.StyleFunction.
    \@param {*} styleObject
    \@returns {ol.StyleFunction}
    \@memberof OlStyleService
     * @param {?} styleObject
     * @return {?}
     */
    OlStyleService.prototype.getStyle = function (styleObject) {
        var /** @type {?} */ self = this;
        return function styleFunction(feature) {
            var /** @type {?} */ style$$1;
            if (styleObject instanceof Function) {
                style$$1 = styleObject(feature);
            }
            else {
                style$$1 = styleObject;
            }
            var /** @type {?} */ styleOptions = {};
            if (style$$1.fill && style$$1.fill.color) {
                styleOptions.fill = self.getFill(style$$1.fill);
            }
            if (style$$1.stroke) {
                styleOptions.stroke = self.getStroke(style$$1.stroke);
            }
            if (style$$1.zIndex) {
                styleOptions.zIndex = style$$1.zIndex;
            }
            if (style$$1.text) {
                styleOptions.text = new style.Text(/** @type {?} */ ({
                    text: style$$1.text.text || undefined,
                    font: style$$1.text.font || undefined,
                    fill: style$$1.text.fill ? self.getFill(style$$1.text.fill) : undefined,
                    stroke: style$$1.text.stroke ? self.getStroke(style$$1.text.stroke) : undefined,
                    overflow: style$$1.text.overflow,
                    maxAngle: style$$1.text.maxAngle || undefined,
                    offsetX: style$$1.text.offsetX || undefined,
                    offsetY: style$$1.text.offsetX || undefined,
                    scale: style$$1.text.scale || undefined,
                    rotateWithView: style$$1.text.rotateWithView,
                    rotation: style$$1.text.rotation || undefined,
                    textAlign: style$$1.text.textAlign || undefined,
                    textBaseline: style$$1.text.textBaseline || undefined,
                    textPlacement: style$$1.text.textPlacement || undefined
                }));
            }
            if (style$$1.image) {
                styleOptions.image = new style.Circle({
                    fill: style$$1.image.fill ? self.getFill(style$$1.image.fill) : undefined,
                    radius: style$$1.image.radius ? style$$1.image.radius : undefined,
                    stroke: style$$1.image.stroke ? self.getStroke(style$$1.image.stroke) : undefined
                });
            }
            return [new style.Style(styleOptions)];
        };
    };
    /**
     * Creates an ol.style.Fill object.
    \@private
    \@param {*} fillOptions color property
    \@returns {ol.style.Fill}
    \@memberof OlStyleService
     * @param {?} fillOptions
     * @return {?}
     */
    OlStyleService.prototype.getFill = function (fillOptions) {
        return new style.Fill({ color: fillOptions.color });
    };
    /**
     * Creates an ol.style.Stroke object.
    \@private
    \@param {*} strokeOptions color & width properties
    \@returns {ol.style.Stroke}
    \@memberof OlStyleService
     * @param {?} strokeOptions
     * @return {?}
     */
    OlStyleService.prototype.getStroke = function (strokeOptions) {
        return new style.Stroke({
            color: strokeOptions.color ? strokeOptions.color : undefined,
            width: strokeOptions.width ? strokeOptions.width : undefined
        });
    };
    return OlStyleService;
}());
OlStyleService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
OlStyleService.ctorParameters = function () { return []; };

/**
 * Constructs an ol.layer.Layer object based on a layer config.
\@export
\@class OlLayerService
 */
var OlLayerService = (function () {
    /**
     * @param {?} http
     * @param {?} mapStore
     * @param {?} styler
     */
    function OlLayerService(http, mapStore, styler) {
        this.http = http;
        this.mapStore = mapStore;
        this.styler = styler;
        this.geoJSON = new format.GeoJSON();
        this.wfsGML = new format.WFS();
    }
    /**
     * The main method which calls the construction methods based on
    the layer type and returns an ol.layer.Layer
    through an observable.
    \@public
    \@param {*} layer
    \@returns {Observable<ol.layer.Layer>}
    \@memberof OlLayerService
     * @param {?} layer
     * @return {?}
     */
    OlLayerService.prototype.getLayer = function (layer$$1) {
        var _this = this;
        return new Observable$1(function (observer) {
            switch (layer$$1.source.type.toUpperCase()) {
                case 'WMS':
                    if (!layer$$1.source.url || !layer$$1.source.params || !layer$$1.source.params.LAYERS) {
                        console.error('VitoJS: Creation of WMS layer failed. Please provide url and parameters.');
                        observer.next(null);
                        return;
                    }
                    if (layer$$1.source.params.TILED) {
                        observer.next(_this.getTiledWMS(layer$$1));
                    }
                    else {
                        observer.next(_this.getWMS(layer$$1));
                    }
                    break;
                case 'WFS':
                    if (!layer$$1.source.url || !layer$$1.source.layer) {
                        console.error('VitoJS: Creation of WFS layer failed. Please provide url and layer name.');
                        observer.next(null);
                        return;
                    }
                    observer.next(_this.getVector(layer$$1));
                    break;
                case 'WMTS':
                    if (!layer$$1.source.url || !layer$$1.source.layer) {
                        console.error('VitoJS: Creation of WMTS layer failed. Please provide url and layer name.');
                        observer.next(null);
                        return;
                    }
                    _this.getWMTS(layer$$1).subscribe(function (olLayer) { return observer.next(olLayer); });
                    break;
                case 'MVT':
                    if (!layer$$1.source.url || !layer$$1.source.layer) {
                        console.error('VitoJS: Creation of MVT layer failed. Please provide url and layer name.');
                        observer.next(null);
                        return;
                    }
                    observer.next(_this.getMVT(layer$$1));
                    break;
                case 'OSM':
                    observer.next(_this.getOSM(layer$$1));
                    break;
                case 'MAPBOX':
                    if (!layer$$1.source.style || !layer$$1.source.token) {
                        console.error('VitoJS: Creation of Mapbox layer failed. Please provide style and access token');
                        observer.next(null);
                        return;
                    }
                    observer.next(_this.getMapbox(layer$$1));
                    break;
                case 'VECTOR':
                    observer.next(_this.getVector(layer$$1));
                    break;
                default:
                    console.error('VitoJS: Layer creation failed. The type provided is not supported by the framework.');
                    observer.next(null);
                    return;
            }
        });
    };
    /**
     * Creates an OSM Layer.
    \@private
    \@param {*} layer
    \@returns {ol.layer.Tile}
    \@memberof OlLayerService
     * @param {?} layer
     * @return {?}
     */
    OlLayerService.prototype.getOSM = function (layer$$1) {
        var /** @type {?} */ osmOptions = Object.assign({}, layer$$1);
        osmOptions.source = new source.OSM();
        return new layer.Tile(osmOptions);
    };
    /**
     * Creates a Mapbox Layer based on a style, userId & token.
    \@private
    \@param {*} layer
    \@returns {ol.layer.Tile}
    \@memberof OlLayerService
     * @param {?} layer
     * @return {?}
     */
    OlLayerService.prototype.getMapbox = function (layer$$1) {
        var /** @type {?} */ mapboxOptions = Object.assign({}, layer$$1);
        mapboxOptions.source = new source.XYZ({
            url: "https://api.mapbox.com/styles/v1/" + (layer$$1.source.userId ? layer$$1.source.userId : 'mapbox') + "/" + layer$$1.source.style + "/tiles/256/{z}/{x}/{y}?access_token=" + layer$$1.source.token
        });
        return new layer.Tile(mapboxOptions);
    };
    /**
     * Can create a WFS Layer as well as a simple vectorLayer,
    based on a layer config parameter.
    \@private
    \@param {*} layer
    \@returns {ol.layer.Vector}
    \@memberof OlLayerService
     * @param {?} layer
     * @return {?}
     */
    OlLayerService.prototype.getVector = function (layer$$1) {
        var /** @type {?} */ vectorSource = this.getVectorSource(layer$$1.source);
        if (layer$$1.source.cluster && layer$$1.source.cluster.animated) {
            var /** @type {?} */ source$$1 = new ol_layer_AnimatedCluster({
                name: layer$$1.id,
                source: vectorSource,
                style: layer$$1.style ? this.styler.getStyle(layer$$1.style) : undefined,
                renderMode: layer$$1.source.minZoom ? 'image' : 'vector'
            });
            console.log(source$$1);
            return source$$1;
        }
        else {
            return new layer.Vector(Object.assign(layer$$1, {
                source: vectorSource,
                style: layer$$1.style ? this.styler.getStyle(layer$$1.style) : undefined,
                renderMode: layer$$1.source.minZoom ? 'image' : 'vector'
            }));
        }
    };
    /**
     * @param {?} layer
     * @return {?}
     */
    OlLayerService.prototype.getMVT = function (layer$$1) {
        //let wmsUrl = `${layer.source.url}?service=WMS&request=GetCapabilities`;
        //let wmsOptions = Object.assign({}, layer);
        //wmsOptions.source = new ol.source.ImageWMS(layer.source);
        var /** @type {?} */ vectorTileSource = new source.VectorTile({
            format: new format.MVT({
                featureClass: Feature,
            }),
            url: layer$$1.source.url,
            //projection: this.mapStore.getProjection(),
            transition: 0
        });
        try {
            this.setVectorSourceEvents(vectorTileSource);
        }
        catch (e) {
            console.error('vectorsourceevents', e);
        }
        return new layer.VectorTile({
            id: layer$$1.id,
            updateWhileAnimating: true,
            declutter: true,
            source: vectorTileSource,
            style: layer$$1.style ? this.styler.getStyle(layer$$1.style) : undefined,
        });
    };
    /**
     * Create an ol.source.Vector based on a source config.
    Used by getVector method.
    \@private
    \@param {*} source
    \@returns {ol.source.Vector}
    \@memberof OlLayerService
     * @param {?} source
     * @return {?}
     */
    OlLayerService.prototype.getVectorSource = function (source$$1) {
        var /** @type {?} */ vectorSource;
        if (source$$1.hasOwnProperty('url')) {
            var /** @type {?} */ wfsUrl = "$url$?service=WFS&request=GetFeature&version=1.1.0&typename=$layer$&outputFormat=application/json&srsname=$proj$";
            var /** @type {?} */ url_1 = source$$1.type === 'WFS' ? wfsUrl.replace('$url$', source$$1.url).replace('$layer$', source$$1.layer).replace('$proj$', this.mapStore.getProjection()) : source$$1.url;
            if (source$$1.minZoom) {
                var /** @type {?} */ zoom_1;
                var /** @type {?} */ vSource = new source.Vector({
                    format: new format.GeoJSON(),
                    url: function (extent$$1, resolution, projection) {
                        vectorSource.dispatchEvent('vectorloadstart');
                        if (zoom_1 && zoom_1 > source$$1.minZoom) {
                            return url_1 + ("&bbox=" + extent$$1.join(',') + ",EPSG:3857");
                        }
                        else {
                            return 'assets/empty-WFS.json';
                        }
                    },
                    strategy: loadingstrategy.bbox
                });
                this.mapStore.getMap().on('moveend', function (event) {
                    zoom_1 = event.target.getView().getZoom();
                    vectorSource.clear();
                });
                vectorSource = vSource;
            }
            else {
                vectorSource = new source.Vector({
                    format: new format.GeoJSON({
                        defaultDataProjection: source$$1.projection ? source$$1.projection : this.mapStore.getProjection(),
                        featureProjection: this.mapStore.getProjection()
                    }),
                    url: url_1
                });
            }
        }
        else {
            var /** @type {?} */ vSource = void 0;
            /* if (source.minZoom) {
                let features = this.geoJsonToFeatures(source.features, source.projection);
                let zoom;
                vSource = new ol.source.Vector({
                    format: new ol.format.GeoJSON(),
                    loader: function(extent, resolution, projection) {
                        if (zoom && zoom > source.minZoom) {
                            vectorSource.dispatchEvent('vectorloadstart');
                            vectorSource.clear();
                            vectorSource.addFeatures(features);
                        }
                    },
                    strategy: ol.loadingstrategy.bbox
                });
                this.mapStore.getMap().on('moveend', (event) => {
                    zoom = event.target.getView().getZoom();
                    if (vectorSource.getFeatures().length > 0) { features = vectorSource.getFeatures(); }
                    vectorSource.clear();
                });
            } else { */
            vSource = new source.Vector({
                features: this.geoJsonToFeatures(source$$1.features, source$$1.projection)
            });
            /* } */
            if (source$$1.cluster) {
                vSource = new source.Cluster({
                    distance: (source$$1.cluster.distance ? source$$1.cluster.distance : 30),
                    source: vSource
                });
            }
            vectorSource = vSource;
        }
        this.setVectorSourceEvents(vectorSource);
        return vectorSource;
    };
    /**
     * @param {?} vectorSource
     * @return {?}
     */
    OlLayerService.prototype.setVectorSourceEvents = function (vectorSource) {
        vectorSource.on('change', function (event) {
            switch (vectorSource.getState()) {
                case 'ready':
                    setTimeout(function () {
                        vectorSource.dispatchEvent('vectorloadend');
                    });
                    break;
                case 'error':
                    setTimeout(function () {
                        vectorSource.dispatchEvent('vectorloaderror');
                    });
                    break;
            }
        });
    };
    /**
     * Creates a WMTS Layer based on a layer config.
    Returns an observable because GetCapabilities request is needed.
    \@private
    \@param {*} layer
    \@returns {Observable<ol.layer.Tile>}
    \@memberof OlLayerService
     * @param {?} layer
     * @return {?}
     */
    OlLayerService.prototype.getWMTS = function (layer$$1) {
        var _this = this;
        var /** @type {?} */ wmtsUrl = layer$$1.source.url + "?service=WMTS&request=GetCapabilities&version=1.0.0";
        return this.http
            .get(wmtsUrl)
            .map(function (response) {
            var /** @type {?} */ wmtsOptions = Object.assign({}, layer$$1);
            var /** @type {?} */ xml = response.text();
            var /** @type {?} */ xmlParser = new format.WMTSCapabilities();
            var /** @type {?} */ time = layer$$1.source.time;
            var /** @type {?} */ format$$1 = layer$$1.source.format;
            var /** @type {?} */ sourceOptions = source.WMTS.optionsFromCapabilities(xmlParser.read(xml), {
                layer: layer$$1.source.layer,
                projection: _this.mapStore.getProjection()
            });
            /*
                 Bug #502 of Geowebcache (https://github.com/GeoWebCache/geowebcache/issues/520): Incorrect namespace is included in the dimensions
                 of a layer configuration.This results in an incorrect capabilities that does not include dimension identifier.

                 Impact: the time dimension is recognized as "undefined"
             */
            if (sourceOptions.dimensions && ((sourceOptions.dimensions)).undefined && !isNaN(Date.parse(((sourceOptions.dimensions)).undefined))) {
                sourceOptions.dimensions = { 'TIME': (new Date(((sourceOptions.dimensions)).undefined)).toISOString() };
            }
            if (sourceOptions) {
                if (layer$$1.source.tileLoadFunction) {
                    sourceOptions.tileLoadFunction = layer$$1.source.tileLoadFunction;
                }
                else {
                    sourceOptions.tileLoadFunction = function (imageTile, src) {
                        ((((imageTile)).getImage())).src = src;
                    };
                }
            }
            if (time) {
                sourceOptions.dimensions = { TIME: time.toISOString() };
            }
            if (format$$1) {
                sourceOptions.format = format$$1;
            }
            wmtsOptions.source = new source.WMTS(sourceOptions);
            wmtsOptions.source.set('wmsUrl', layer$$1.source.wmsUrl);
            return new layer.Tile(wmtsOptions);
        })
            .catch(function (error) {
            console.error("VitoJS: Creation of WMTS layer " + layer$$1.id + " failed. The WMTS configuration might not be valid. Please check whether the url is correct.");
            return Observable$1.of(null);
        });
    };
    /**
     * Creates a WMS Layer based on a layer config.
    \@private
    \@param {*} layer
    \@returns {ol.layer.Image}
    \@memberof OlLayerService
     * @param {?} layer
     * @return {?}
     */
    OlLayerService.prototype.getWMS = function (layer$$1) {
        var /** @type {?} */ wmsUrl = layer$$1.source.url + "?service=WMS&request=GetCapabilities";
        var /** @type {?} */ wmsOptions = Object.assign({}, layer$$1);
        wmsOptions.source = new source.ImageWMS(layer$$1.source);
        return new layer.Image(wmsOptions);
    };
    /**
     * Creates a Tiled WMS based on a layer config.
    \@private
    \@param {*} layer
    \@returns {ol.layer.Tile}
    \@memberof OlLayerService
     * @param {?} layer
     * @return {?}
     */
    OlLayerService.prototype.getTiledWMS = function (layer$$1) {
        var /** @type {?} */ wmsUrl = layer$$1.source.url + "?service=WMS&request=GetCapabilities";
        var /** @type {?} */ wmsOptions = Object.assign({}, layer$$1);
        wmsOptions.source = new source.TileWMS(layer$$1.source);
        return new layer.Tile(wmsOptions);
    };
    /**
     * Converts GeoJSON objects to openlayers features.
    \@public
    \@param {(any | any[])} geojson
    \@param {string} [projection] The projection for the openlayers features. Default is map projection.
    \@returns {ol.Feature[]}
    \@memberof OlLayerService
     * @param {?} geojson
     * @param {?=} projection
     * @return {?}
     */
    OlLayerService.prototype.geoJsonToFeatures = function (geojson, projection) {
        var /** @type {?} */ formatter = new format.GeoJSON({
            defaultDataProjection: projection ? projection : this.mapStore.getProjection(),
            featureProjection: this.mapStore.getProjection()
        });
        if (Array.isArray(geojson)) {
            var /** @type {?} */ olFeatures_1 = [];
            geojson.forEach(function (feat) {
                olFeatures_1 = olFeatures_1.concat(formatter.readFeatures(feat));
            });
            return olFeatures_1;
        }
        else {
            return formatter.readFeatures(geojson);
        }
    };
    return OlLayerService;
}());
OlLayerService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
OlLayerService.ctorParameters = function () { return [
    { type: Http, },
    { type: MapStore, },
    { type: OlStyleService, },
]; };

/**
 * A component which can be used to create an ol.layer.Layer.
\@export
\@class LayerComponent
\@property {string} id The unique identifier for the layer
\@property {any} source Object with data about (the source of) the layer. Depends on layer type.
\@property {boolean} visible Visibility. Default is true.
\@property {number} zIndex The z-index for layer rendering. At rendering time, the layers will be ordered, first by Z-index and then by position. The default Z-index is 0.
\@property {number} opacity Opacity (0, 1). Default is 1.
\@property {number} minResolution The minimum resolution (inclusive) at which this layer will be visible.
\@property {number} maxResolution The maximum resolution (exclusive) below which this layer will be visible.
\@property {any} style Layer style. See ol.style for default style which will be used if this is not defined.
\@property {any} layerOptions extra options for the layer.
\@implements {OnInit}
\@implements {OnDestroy}
\@implements {OnChanges}
 */
var LayerComponent = (function () {
    /**
     * @param {?} actions
     * @param {?} olLayer
     * @param {?} styler
     */
    function LayerComponent(actions, olLayer, styler) {
        this.actions = actions;
        this.olLayer = olLayer;
        this.styler = styler;
    }
    /**
     * Retrieves ol.layer.Layer object and puts it in the mapstore
    \@returns
    \@memberof LayerComponent
     * @return {?}
     */
    LayerComponent.prototype.ngOnInit = function () {
        var _this = this;
        var /** @type {?} */ layer$$1 = this.getLayerConfiguration();
        if (!layer$$1) {
            return;
        }
        this.olLayer.getLayer(layer$$1).subscribe(function (olLayer) {
            if (!olLayer) {
                return;
            }
            _this.instance = olLayer;
            if (_this.visible !== undefined) {
                _this.instance.setVisible(_this.visible);
            }
            if (_this.zIndex !== undefined) {
                _this.instance.setZIndex(_this.zIndex);
            }
            if (_this.opacity !== undefined) {
                _this.instance.setOpacity(_this.opacity);
            }
            _this.actions.addLayer(_this.instance);
        });
    };
    /**
     * Sets certain changes (visible, zIndex, opacity,...) to the ol.layer.Layer object.
    \@param {SimpleChanges} changes
    \@returns
    \@memberof LayerComponent
     * @param {?} changes
     * @return {?}
     */
    LayerComponent.prototype.ngOnChanges = function (changes) {
        if (!this.instance) {
            return;
        }
        if (changes.style && this.instance.setStyle) {
            this.instance.setStyle(this.style ? this.styler.getStyle(this.style) : undefined);
        }
        if (changes.visible && changes.visible.currentValue != null) {
            this.instance.setVisible(this.visible);
        }
        if (changes.zIndex && changes.zIndex.currentValue != null) {
            this.instance.setZIndex(this.zIndex);
        }
        if (changes.opacity && changes.opacity.currentValue != null) {
            this.instance.setOpacity(this.opacity);
        }
        if (changes.minResolution && changes.minResolution.currentValue != null) {
            this.instance.setMinResolution(this.minResolution);
        }
        if (changes.maxResolution && changes.maxResolution.currentValue != null) {
            this.instance.setMaxResolution(this.maxResolution);
        }
        if (changes.source && changes.source.currentValue.features) {
            ((this.instance.getSource())).clear();
            ((this.instance.getSource())).addFeatures(this.olLayer.geoJsonToFeatures(this.source.features, this.source.projection));
        }
        if (changes.source && changes.source.currentValue.time) {
            this.actions.updateLayerTime(this.id, this.source.time.toISOString());
            if (this.instance.getSource() instanceof source.WMTS) {
                this.instance.getSource().refresh();
            }
        }
        if (this.instance.getSource() instanceof source.Vector || this.instance.getSource() instanceof source.VectorTile) {
            this.instance.getSource().refresh();
        }
        this.actions.updateLayer(this.instance);
    };
    /**
     * Removes the layer from the mapstore when deleted
    \@memberof LayerComponent
     * @return {?}
     */
    LayerComponent.prototype.ngOnDestroy = function () {
        if (this.instance) {
            this.actions.removeLayer(this.instance);
        }
    };
    /**
     * Checks the input parameters & creates layer configuration object.
    \@returns {any} The layer configuration object.
    \@memberof LayerComponent
     * @return {?}
     */
    LayerComponent.prototype.getLayerConfiguration = function () {
        if (!this.id || !this.source) {
            console.error('VitoJS: Layer creation failed. A layer must have an id and a source object.');
            return null;
        }
        var /** @type {?} */ layer$$1 = { id: this.id, source: this.source, timestamp: new Date().toISOString() };
        if (this.layerOptions) {
            layer$$1 = Object.assign({}, layer$$1, this.layerOptions);
        }
        if (this.minResolution != null) {
            layer$$1.minResolution = this.minResolution;
        }
        if (this.maxResolution != null) {
            layer$$1.maxResolution = this.maxResolution;
        }
        if (this.style) {
            layer$$1.style = this.style;
        }
        return layer$$1;
    };
    return LayerComponent;
}());
LayerComponent.decorators = [
    { type: Component, args: [{
                selector: 'vito-layer',
                template: ''
            },] },
];
/**
 * @nocollapse
 */
LayerComponent.ctorParameters = function () { return [
    { type: MapActions, },
    { type: OlLayerService, },
    { type: OlStyleService, },
]; };
LayerComponent.propDecorators = {
    'id': [{ type: Input },],
    'source': [{ type: Input },],
    'visible': [{ type: Input },],
    'zIndex': [{ type: Input },],
    'opacity': [{ type: Input },],
    'minResolution': [{ type: Input },],
    'maxResolution': [{ type: Input },],
    'style': [{ type: Input },],
    'layerOptions': [{ type: Input },],
};

/**
 * Constructs an ol.interaction.Interaction object based on an interaction config.
\@export
\@class OlInteractionService
 */
var OlInteractionService = (function () {
    /**
     * @param {?} mapStore
     * @param {?} http
     * @param {?} styler
     */
    function OlInteractionService(mapStore, http, styler) {
        this.mapStore = mapStore;
        this.http = http;
        this.styler = styler;
        this.geoJSON = new format.GeoJSON();
    }
    /**
     * The main method which calls the construction methods based on
    the interaction type and returns an ol.interaction.Interaction
    \@param {*} interaction
    \@returns {ol.interaction.Interaction}
    \@memberof OlInteractionService
     * @param {?} interaction
     * @return {?}
     */
    OlInteractionService.prototype.getInteraction = function (interaction$$1) {
        var /** @type {?} */ olInteraction = null;
        switch (interaction$$1.type ? interaction$$1.type.toUpperCase() : '') {
            case 'DRAW':
                olInteraction = this.getDrawInteraction(interaction$$1);
                break;
            case 'MEASURE':
                olInteraction = this.getMeasureInteraction(interaction$$1);
                break;
            case 'SELECT':
                olInteraction = this.getSelectInteraction(interaction$$1, false);
                break;
            case 'MULTI_SELECT':
                olInteraction = this.getSelectInteraction(interaction$$1, true);
                break;
            case 'MODIFY':
                olInteraction = this.getModifyInteraction(interaction$$1);
                break;
            case 'TRANSLATE':
                olInteraction = this.getTranslationInteraction(interaction$$1);
                break;
            case 'MULTITRANSLATE':
                olInteraction = this.getMultiTranslationInteraction(interaction$$1);
                break;
            default:
                console.error('VitoJS: Initializing interaction failed. Invalid interaction type.');
        }
        if (olInteraction) {
            olInteraction.set('id', interaction$$1.id);
            olInteraction.setActive(interaction$$1.active);
        }
        return olInteraction;
    };
    /**
     * Creates a Draw interaction, possible to draw a Point,
    Linestring, Polygon & Rectangle
    \@private
    \@param {*} interaction
    \@returns {ol.interaction.Interaction}
    \@memberof OlInteractionService
     * @param {?} interaction
     * @return {?}
     */
    OlInteractionService.prototype.getDrawInteraction = function (interaction$$1) {
        if (interaction$$1.geometryType) {
            var /** @type {?} */ g = interaction$$1.geometryType;
            if (g === 'Point' || g === 'LineString' || g === 'Polygon') {
                var /** @type {?} */ olInteraction = new interaction.Draw({
                    type: interaction$$1.geometryType,
                    style: interaction$$1.style ? this.styler.getStyle(interaction$$1.style) : undefined
                });
                olInteraction.on('drawend', function (evt) {
                    var /** @type {?} */ geojson = new format.GeoJSON();
                    var /** @type {?} */ feature = JSON.parse(geojson.writeFeature(evt.feature));
                    feature.properties = null;
                    interaction$$1.interaction.next(feature);
                });
                return olInteraction;
            }
            else if (g === 'Rectangle') {
                var /** @type {?} */ olInteraction = new interaction.Draw({
                    type: 'Circle',
                    geometryFunction: interaction.Draw.createBox(),
                    style: interaction$$1.style ? this.styler.getStyle(interaction$$1.style) : undefined
                });
                olInteraction.on('drawend', function (evt) {
                    var /** @type {?} */ geojson = new format.GeoJSON();
                    var /** @type {?} */ feature = JSON.parse(geojson.writeFeature(evt.feature));
                    feature.properties = null;
                    interaction$$1.interaction.next(feature);
                });
                return olInteraction;
            }
            else {
                console.error("VitoJS: Invalid geometryType, please use one of these: [Point, LineString, Polygon]");
                return null;
            }
        }
        else {
            console.error("VitoJS: No geometryType was specified, provide the component with a valid type");
            return null;
        }
    };
    /**
     * Creates a Measure interaction, same as Draw but with
    a measurement property included.
    \@private
    \@param {*} interaction
    \@returns {ol.interaction.Interaction}
    \@memberof OlInteractionService
     * @param {?} interaction
     * @return {?}
     */
    OlInteractionService.prototype.getMeasureInteraction = function (interaction$$1) {
        if (interaction$$1.geometryType) {
            var /** @type {?} */ g = interaction$$1.geometryType;
            if (g === 'Point' || g === 'LineString' || g === 'Polygon') {
                var /** @type {?} */ olInteraction = new interaction.Draw({
                    type: interaction$$1.geometryType,
                    style: interaction$$1.style ? this.styler.getStyle(interaction$$1.style) : undefined
                });
                olInteraction.on('drawend', function (event) {
                    var /** @type {?} */ geojson = new format.GeoJSON();
                    var /** @type {?} */ feature = JSON.parse(geojson.writeFeature(event.feature));
                    var /** @type {?} */ geometry = event.feature.getGeometry();
                    var /** @type {?} */ measurement = undefined;
                    if (geometry.getLength) {
                        measurement = Math.round(geometry.getLength() * 100) / 100;
                    }
                    else if (geometry.getArea) {
                        measurement = Math.round(geometry.getArea() * 100) / 100;
                    }
                    else if (geometry.getCoordinates) {
                        measurement = geometry.getCoordinates();
                    }
                    feature.properties = {
                        measurement: measurement
                    };
                    interaction$$1.interaction.next(feature);
                });
                return olInteraction;
            }
            else {
                console.error("VitoJS: Invalid geometryType, please use one of these: [Point, LineString, Polygon]");
                return null;
            }
        }
        else {
            console.error("VitoJS: No geometryType was specified, provide the component with a valid type");
            return null;
        }
    };
    /**
     * Creates a select interaction. Possible to create select interaction
    to a vectorLayer & an image layer (WMS, WMTS) and also possible to
    select with a rectangle.
    \@private
    \@param {*} interaction
    \@param {boolean} multiSelect
    \@returns {ol.interaction.Interaction}
    \@memberof OlInteractionService
     * @param {?} interaction
     * @param {?} multiSelect
     * @return {?}
     */
    OlInteractionService.prototype.getSelectInteraction = function (interaction$$1, multiSelect) {
        var _this = this;
        var /** @type {?} */ selectInteraction;
        if (interaction$$1.layer && interaction$$1.layer.length > 0) {
            if (interaction$$1.layer.filter(function (lyr) {
                return lyr.getSource() instanceof source.Vector || lyr.getSource() instanceof source.VectorTile;
            }).length > 0) {
                interaction$$1.layer = interaction$$1.layer.filter(function (lyr) {
                    return lyr.getSource() instanceof source.Vector || lyr.getSource() instanceof source.VectorTile;
                });
                if (interaction$$1.geometryType === 'rectangle') {
                    selectInteraction = new interaction.DragBox({ className: 'ol-dragBox' });
                    selectInteraction.on('boxend', function (event) {
                        var /** @type {?} */ extent$$1 = selectInteraction.getGeometry().getExtent();
                        interaction$$1.layer.forEach(function (layer$$1) {
                            layer$$1.getSource().forEachFeatureIntersectingExtent(extent$$1, function (ft) {
                                interaction$$1.interaction.next(_this.geoJSON.writeFeatureObject(ft));
                            });
                        });
                    });
                }
                else {
                    var /** @type {?} */ interActionOptions = {
                        layers: interaction$$1.layer,
                        condition: events.condition.click
                    };
                    if (multiSelect) {
                        interActionOptions['toggleCondition'] = events.condition.shiftKeyOnly;
                    }
                    selectInteraction = new interaction.Select(interActionOptions);
                    selectInteraction.on('select', function (event) {
                        if (multiSelect) {
                            var /** @type {?} */ featureObjects = selectInteraction.getFeatures().getArray().map(function (olFeature) {
                                return _this.geoJSON.writeFeatureObject(olFeature);
                            });
                            interaction$$1.interaction.next(featureObjects);
                        }
                        else {
                            event.selected.forEach(function (olFeature) {
                                interaction$$1.interaction.next(_this.geoJSON.writeFeatureObject(olFeature));
                            });
                            selectInteraction.getFeatures().clear();
                        }
                    });
                }
            }
            else if (interaction$$1.layer.filter(function (lyr) { return lyr.getSource() instanceof source.ImageWMS
                || lyr.getSource() instanceof source.WMTS; }).length > 0) {
                interaction$$1.layer = interaction$$1.layer.filter(function (lyr) { return lyr.getSource() instanceof source.ImageWMS
                    || lyr.getSource() instanceof source.WMTS; });
                var /** @type {?} */ wmsSources_1 = [];
                interaction$$1.layer.forEach(function (layer$$1) {
                    if (layer$$1.getSource() instanceof source.ImageWMS) {
                        wmsSources_1.push(layer$$1.getSource());
                    }
                    else if (layer$$1.getSource() instanceof source.WMTS && layer$$1.getSource().get('wmsUrl')) {
                        wmsSources_1.push(new source.ImageWMS({
                            url: layer$$1.getSource().get('wmsUrl'),
                            params: {
                                LAYERS: layer$$1.getSource().getLayer()
                            },
                            projection: _this.mapStore.getProjection()
                        }));
                    }
                    else {
                        console.error("VitoJS: No valid WMS source type for layer " + interaction$$1.layer.id);
                        return;
                    }
                });
                selectInteraction = new interaction.Interaction({
                    handleEvent: function (event) {
                        if (event.type === 'click' && interaction$$1.layer[0].getVisible()) {
                            var /** @type {?} */ res_1 = event.map.getView().getResolution();
                            var /** @type {?} */ proj_1 = _this.mapStore.getProjection();
                            wmsSources_1.forEach(function (wmsSource) {
                                var /** @type {?} */ url = wmsSource.getGetFeatureInfoUrl(event.coordinate, res_1, proj_1, { 'INFO_FORMAT': 'application/json' });
                                _this.http.get(url).subscribe(function (response) {
                                    var /** @type {?} */ jsonResponse = response.json();
                                    if (jsonResponse.features) {
                                        jsonResponse.features.forEach(function (feature) {
                                            interaction$$1.interaction.next(feature);
                                        });
                                    }
                                    else {
                                        interaction$$1.interaction.next(jsonResponse);
                                    }
                                });
                            });
                        }
                        return true;
                    }
                });
            }
            else {
                console.error('VitoJS: Initializing interaction failed. Select interaction does not support this kind of layer.');
                return;
            }
        }
        else {
            console.error("VitoJS: No layer was found for " + interaction$$1.type + " interaction.");
            return;
        }
        return selectInteraction;
    };
    /**
     * Creates a Modify interaction. Only possible with a vectorLayer.
    \@private
    \@param {*} interaction
    \@returns {ol.interaction.Interaction}
    \@memberof OlInteractionService
     * @param {?} interaction
     * @return {?}
     */
    OlInteractionService.prototype.getModifyInteraction = function (interaction$$1) {
        var _this = this;
        if (interaction$$1.layer && interaction$$1.layer.length > 0) {
            if (interaction$$1.layer.length > 1) {
                console.error("VitoJS: The modify interaction does not support multiple layerIds. The first is used.");
            }
            interaction$$1.layer = interaction$$1.layer[0];
            if (interaction$$1.layer.getSource() instanceof source.Vector) {
                var /** @type {?} */ olInteraction = new interaction.Modify({
                    source: interaction$$1.layer.getSource()
                });
                var /** @type {?} */ feat_1 = ((this.geoJSON.writeFeaturesObject(interaction$$1.layer.getSource().getFeatures()))).features.map(function (f) { return f.geometry.coordinates; });
                olInteraction.on('modifyend', function (event) {
                    var /** @type {?} */ modFeat = ((_this.geoJSON.writeFeaturesObject(event.features.getArray()))).features;
                    modFeat.forEach(function (f, idx) {
                        if (JSON.stringify(f.geometry.coordinates) !== JSON.stringify(feat_1[idx])) {
                            interaction$$1.interaction.next(f);
                        }
                    });
                    feat_1 = modFeat.map(function (f) { return f.geometry.coordinates; });
                });
                return olInteraction;
            }
            else {
                console.error("VitoJS: The layer for the modify interaction is not a vector layer");
                return;
            }
        }
        else {
            console.error("VitoJS: No layer was found for " + interaction$$1.type + " interaction.");
            return;
        }
    };
    /**
     * Creates a Translation interaction. Only possible with a vectorLayer.
    \@private
    \@param {*} interaction
    \@returns {ol.interaction.Interaction}
    \@memberof OlInteractionService
     * @param {?} interaction
     * @return {?}
     */
    OlInteractionService.prototype.getTranslationInteraction = function (interaction$$1) {
        var _this = this;
        if (interaction$$1.layer && interaction$$1.layer.length > 0) {
            if (interaction$$1.layer.filter(function (lyr) { return lyr.getSource() instanceof source.Vector; }).length > 0) {
                interaction$$1.layer = ((interaction$$1.layer.filter(function (lyr) { return lyr.getSource() instanceof source.Vector; })));
                var /** @type {?} */ olInteraction = new interaction.Translate({
                    layers: interaction$$1.layer
                });
                olInteraction.on('translateend', function (event) {
                    event.features.getArray().forEach(function (olFeature) {
                        interaction$$1.interaction.next(_this.geoJSON.writeFeatureObject(olFeature));
                    });
                });
                return olInteraction;
            }
            else {
                console.error("VitoJS: The layer for the translation interaction is not a vector layer");
                return;
            }
        }
        else {
            console.error("VitoJS: No layer was found for " + interaction$$1.type + " interaction.");
            return;
        }
    };
    /**
     * Creates a Multi-translationInteraction capable of
    translating multiple features at once.
    \@private
    \@param {*} interaction
    \@returns {ol.interaction.Interaction}
    \@memberof OlInteractionService
     * @param {?} interaction
     * @return {?}
     */
    OlInteractionService.prototype.getMultiTranslationInteraction = function (interaction$$1) {
        var _this = this;
        if (interaction$$1.layer && interaction$$1.layer.length > 0) {
            if (interaction$$1.layer.filter(function (lyr) { return lyr.getSource() instanceof source.Vector; }).length > 0) {
                interaction$$1.layer = ((interaction$$1.layer.filter(function (lyr) { return lyr.getSource() instanceof source.Vector; })));
                var /** @type {?} */ olInteraction = new interaction.Translate({
                    layers: interaction$$1.layer
                });
                var /** @type {?} */ features_1 = [];
                interaction$$1.layer.forEach(function (lyr) {
                    features_1 = features_1.concat(lyr.getSource().getFeatures());
                });
                var /** @type {?} */ coordinate_1;
                olInteraction.on('translatestart', function (event) {
                    coordinate_1 = event.coordinate;
                });
                olInteraction.on('translateend', function (event) {
                    var /** @type {?} */ deltaX = event.coordinate[0] - coordinate_1[0];
                    var /** @type {?} */ deltaY = event.coordinate[1] - coordinate_1[1];
                    features_1
                        .filter(function (ft) { return ft.getId() !== event.features.getArray()[0].getId(); })
                        .forEach(function (feat) {
                        ((feat.getGeometry())).translate(deltaX, deltaY);
                    });
                    interaction$$1.interaction.next(_this.geoJSON.writeFeaturesObject(features_1));
                });
                return olInteraction;
            }
            else {
                console.error("VitoJS: The layer for the translation interaction is not a vector layer");
                return;
            }
        }
        else {
            console.error("VitoJS: No layer was found for " + interaction$$1.type + " interaction.");
            return;
        }
    };
    return OlInteractionService;
}());
OlInteractionService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
OlInteractionService.ctorParameters = function () { return [
    { type: MapStore, },
    { type: Http, },
    { type: OlStyleService, },
]; };

/**
 * A component which can be used to create an ol.interaction.Interaction.
\@export
\@class InteractionComponent
\@property {string | string[]} layerId The id of the layer on which the interaction takes place
\@property {string} type The type of interaction (SELECT, DRAW, MEASURE, MODIFY, TRANSLATE, MULTI_SELECT, MULTITRANSLATE)
\@property {string} geometryType In case of a DRAW/MEASURE interaction (POINT, LINESTRING, POLYGON, RECTANGLE)
\@property {any} style Style for the features interacted with. By default the default edit style is used
\@property {boolean} active Wether the interaction is currently active
\@property {EventEmitter<any>} onInteract Emits the features as a result of the interaction
\@implements {OnInit}
\@implements {OnDestroy}
\@implements {OnChanges}
 */
var InteractionComponent = (function () {
    /**
     * @param {?} actions
     * @param {?} mapStore
     * @param {?} olInteraction
     */
    function InteractionComponent(actions, mapStore, olInteraction) {
        var _this = this;
        this.actions = actions;
        this.mapStore = mapStore;
        this.olInteraction = olInteraction;
        this.active = true;
        this.onInteract = new EventEmitter();
        this.feature = new Subject();
        this.broken = false;
        this.feature.subscribe(function (feat) { return _this.onInteract.emit(feat); });
    }
    /**
     * Checks wether the type is correct, and retrieves the ol.layer.Layer object
    from the mapstore needed to create the interaction.
    Finally it calls addInteraction().
    \@returns
    \@memberof InteractionComponent
     * @return {?}
     */
    InteractionComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.type) {
            if ((this.type.toUpperCase() === 'SELECT' || this.type.toUpperCase() === 'MULTI_SELECT' || this.type.toUpperCase() === 'MODIFY' || this.type.toUpperCase() === 'TRANSLATE' || this.type.toUpperCase() === 'MULTITRANSLATE') && !this.layerId) {
                console.error("VitoJS: Initializing interaction failed. Invalid layer id for " + this.type.toUpperCase() + " interaction.");
                return;
            }
            else if ((this.type.toUpperCase() === 'DRAW' || this.type.toUpperCase() === 'MEASURE')) {
                this.addInteraction();
                return;
            }
            this.mapStore.state
                .takeWhile(function () { return (!_this.broken); })
                .subscribe(function (newState) {
                _this.layerId = Array.isArray(_this.layerId) ? _this.layerId : [_this.layerId];
                var /** @type {?} */ layerFound = ((_this.layerId)).map(function (id) { return newState.layers.find(function (lyr) { return lyr.get('id') === id; }); }).filter(function (lyr) { return lyr; });
                if (layerFound.length === ((_this.layerId)).length) {
                    if (_this.newLayer && _this.newLayer.length === layerFound.length) {
                        var /** @type {?} */ bool_1 = true;
                        layerFound.forEach(function (layer$$1, idx) {
                            if (_this.newLayer[idx] !== layerFound[idx].get('timestamp')) {
                                bool_1 = false;
                            }
                        });
                        if (!bool_1) {
                            _this.newLayer = layerFound.map(function (lyr) { return lyr.get('timestamp'); });
                            _this.addInteraction(layerFound);
                        }
                    }
                    else {
                        _this.newLayer = layerFound.map(function (lyr) { return lyr.get('timestamp'); });
                        _this.addInteraction(layerFound);
                    }
                }
            });
        }
    };
    /**
     * If the active input parameter changes, it is changed on the interaction
    \@param {SimpleChanges} changes
    \@memberof InteractionComponent
     * @param {?} changes
     * @return {?}
     */
    InteractionComponent.prototype.ngOnChanges = function (changes) {
        if (this.instance) {
            if (changes.active) {
                this.instance.setActive(this.active);
            }
        }
    };
    /**
     * Gets the ol.interaction.Interaction object from the interaction service,
    and adds it to the mapstore.
    \@param {any} [layer] The ol.layer.Layer object, if necessairy
    \@memberof InteractionComponent
     * @param {?=} layer
     * @return {?}
     */
    InteractionComponent.prototype.addInteraction = function (layer$$1) {
        if (this.instance) {
            this.actions.removeInteraction(this.instance);
        }
        this.instance = this.olInteraction.getInteraction({
            id: (this.layerId || this.geometryType || '') + "_" + (this.type ? this.type.toLowerCase() : ''),
            layer: layer$$1,
            geometryType: this.geometryType,
            type: this.type,
            style: this.style,
            active: this.active,
            interaction: this.feature
        });
        if (this.instance) {
            this.actions.addInteraction(this.instance);
        }
        else {
            this.broken = true;
        }
    };
    /**
     * Removes the interaction from the mapstore when deleted
    \@memberof InteractionComponent
     * @return {?}
     */
    InteractionComponent.prototype.ngOnDestroy = function () {
        if (this.instance) {
            this.actions.removeInteraction(this.instance);
        }
    };
    return InteractionComponent;
}());
InteractionComponent.decorators = [
    { type: Component, args: [{
                selector: 'vito-interaction',
                template: '',
            },] },
];
/**
 * @nocollapse
 */
InteractionComponent.ctorParameters = function () { return [
    { type: MapActions, },
    { type: MapStore, },
    { type: OlInteractionService, },
]; };
InteractionComponent.propDecorators = {
    'layerId': [{ type: Input },],
    'type': [{ type: Input },],
    'geometryType': [{ type: Input },],
    'style': [{ type: Input },],
    'active': [{ type: Input },],
    'onInteract': [{ type: Output },],
};

var ThumbnailComponent = (function () {
    /**
     * @param {?} mapStore
     * @param {?} http
     * @param {?} domSanitizationService
     */
    function ThumbnailComponent(mapStore, http, domSanitizationService) {
        this.mapStore = mapStore;
        this.http = http;
        this.domSanitizationService = domSanitizationService;
        this.highlighted = false;
        this.baseUrl = '';
        this.urls = undefined;
        this.loadingLayers = [];
        this.loading = {
            base: false,
            layer: {}
        };
        this.hidden = {
            base: false,
            layer: {}
        };
        this.requests = [];
        this.blobRequests = [];
    }
    /**
     * @return {?}
     */
    ThumbnailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.mapStore.state.subscribe(function (newState) {
            if (isNullOrUndefined(_this._layers) || _this._layers.length !== newState.layers.length) {
                _this._layers = newState.layers;
                if (_this._layers) {
                    _this.updateBaseLayer();
                    _this.updateLayer();
                }
            }
        });
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    ThumbnailComponent.prototype.ngOnChanges = function (changes) {
        if (changes["layerId"] && changes["layerId"].currentValue != null && this._layers) {
            this.cancelRequests();
            this.updateLayer();
        }
        if (changes["baseLayer"] && changes["baseLayer"].currentValue != null && this._layers) {
            this.cancelRequests();
            this.updateBaseLayer();
        }
        if (changes["datestring"] && changes["datestring"].currentValue != null && this._layers) {
            this.cancelRequests();
            this.updateLayer();
        }
        if (changes["extent"] && changes["extent"].currentValue != null && this._layers) {
            this.cancelRequests();
            this.updateBaseLayer();
            this.updateLayer();
        }
    };
    /**
     * @return {?}
     */
    ThumbnailComponent.prototype.updateBaseLayer = function () {
        var _this = this;
        var /** @type {?} */ oldUrl = this.baseUrl;
        var /** @type {?} */ baseUrl = "";
        if (this.baseLayer) {
            if (typeof this.baseLayer === "string") {
                var /** @type {?} */ sourceLayer = this._layers.find(function (layer$$1) { return layer$$1.get('id') === _this.baseLayer; });
                if (sourceLayer) {
                    baseUrl = this.getUrlFromLayer(sourceLayer);
                }
            }
            else {
                baseUrl = this.getUrlFromConfig(this.baseLayer);
            }
        }
        else {
            return;
        }
        if (this.baseUrl !== oldUrl) {
            this.loading.base = true;
            this.hidden.base = false;
        }
        else if (baseUrl) {
            this.loading.base = true;
            this.requests.push(this.http.get(baseUrl, { responseType: ResponseContentType.Blob })
                .map(function (res) { return res.blob(); }).subscribe(function (imgData) {
                _this.blobRequests.push(_this.createImageFromBlob(imgData).subscribe(function (img) {
                    _this.baseUrl = img;
                    _this.loading.base = false;
                }));
            }));
        }
        else {
            this.baseUrl = "";
        }
    };
    /**
     * @param {?} image
     * @return {?}
     */
    ThumbnailComponent.prototype.createImageFromBlob = function (image) {
        var /** @type {?} */ url = new Subject();
        var /** @type {?} */ reader = new FileReader();
        reader.addEventListener("load", function () {
            url.next(reader.result);
        }, false);
        if (image) {
            reader.readAsDataURL(image);
        }
        return url;
    };
    /**
     * @return {?}
     */
    ThumbnailComponent.prototype.updateLayer = function () {
        var _this = this;
        var /** @type {?} */ oldUrls = this.urls;
        this.loading.layer = {};
        this.hidden.layer = {};
        this.urls = [];
        var /** @type {?} */ urls = this.layers.map(function (layer$$1) {
            var /** @type {?} */ url = "";
            if (typeof layer$$1 === "string") {
                var /** @type {?} */ sourceLayer = _this._layers.find(function (layerSource) { return layerSource.get('id') === layer$$1; });
                if (sourceLayer) {
                    url = _this.getUrlFromLayer(sourceLayer);
                }
            }
            else {
                url = _this.getUrlFromConfig(layer$$1);
            }
            if (!oldUrls || !oldUrls.length || oldUrls.indexOf(url) === -1) {
                _this.loading.layer[url] = true;
            }
            _this.loadingLayers.push(url);
            return url;
        });
        urls.forEach(function (url) {
            if (url) {
                _this.loading.layer[url] = true;
                _this.requests.push(_this.http.get(url, { responseType: ResponseContentType.Blob })
                    .map(function (res) { return res.blob(); }).subscribe(function (imgData) {
                    _this.blobRequests.push(_this.createImageFromBlob(imgData).subscribe(function (img) {
                        _this.urls.push(img);
                        _this.loading.layer[url] = false;
                    }));
                }));
            }
        });
    };
    /**
     * @param {?} str
     * @return {?}
     */
    ThumbnailComponent.prototype.str2ba = function (str) {
        var /** @type {?} */ buf = new ArrayBuffer(str.length * 2); // 2 bytes for each char
        var /** @type {?} */ bufView = new Uint8Array(buf);
        for (var /** @type {?} */ i = 0, /** @type {?} */ strLen = str.length; i < strLen; i++) {
            bufView[i] = str.charCodeAt(i);
        }
        return buf;
    };
    /**
     * @param {?} layer
     * @return {?}
     */
    ThumbnailComponent.prototype.getUrlFromLayer = function (layer$$1) {
        var /** @type {?} */ bounds = this.getThumbnailExtent(proj.transformExtent(this.extent, 'EPSG:4326', 'EPSG:3857'), this.height, this.width);
        var /** @type {?} */ source$$1 = layer$$1.getSource();
        if (source$$1 instanceof source.OSM) {
            var /** @type {?} */ url = "http://129.206.228.72/cached/osm";
            url += "?SERVICE=WMS&REQUEST=getMap&VERSION=1.3.0&CRS=" + this.mapStore.getProjection();
            url += "&LAYERS=OSM-WMS&STYLES=";
            url += "&BBOX=" + bounds[0] + "," + bounds[1] + "," + bounds[2] + "," + bounds[3];
            url += "&WIDTH=" + this.width + "&HEIGHT=" + this.height;
            url += "&FORMAT=image/png";
            url += "&TRANSPARENT=true";
            return url;
        }
        else if (source$$1 instanceof source.ImageWMS) {
            var /** @type {?} */ params = source$$1.getParams();
            var /** @type {?} */ url = layer$$1.getSource().getUrl();
            url += "?SERVICE=WMS&REQUEST=getMap&VERSION=1.3.0&CRS=" + this.mapStore.getProjection();
            url += "&LAYERS=" + ((params)).LAYERS;
            url += "&STYLES=" + (((params)).STYLES || '');
            if (((params)).SLD_BODY) {
                url += "&SLD_BODY=" + ((params)).SLD_BODY;
            }
            if (this.datestring) {
                url += "&TIME=" + this.datestring;
            }
            url += "&BBOX=" + bounds[0] + "," + bounds[1] + "," + bounds[2] + "," + bounds[3];
            url += "&WIDTH=" + this.width + "&HEIGHT=" + this.height;
            url += "&FORMAT=image/png";
            url += "&TRANSPARENT=true";
            return encodeURI(url).replace(/#/g, encodeURIComponent('#'));
        }
        else if (source$$1 instanceof source.TileWMS) {
            var /** @type {?} */ params = source$$1.getParams();
            var /** @type {?} */ url = layer$$1.getSource().getUrls()[0];
            url += "?SERVICE=WMS&REQUEST=getMap&VERSION=1.3.0&CRS=" + this.mapStore.getProjection();
            url += "&LAYERS=" + ((params)).LAYERS;
            url += "&STYLES=" + (((params)).STYLES || '');
            if (((params)).SLD_BODY) {
                url += "&SLD_BODY=" + ((params)).SLD_BODY;
            }
            if (this.datestring) {
                url += "&TIME=" + this.datestring;
            }
            url += "&BBOX=" + bounds[0] + "," + bounds[1] + "," + bounds[2] + "," + bounds[3];
            url += "&WIDTH=" + this.width + "&HEIGHT=" + this.height;
            url += "&FORMAT=image/png";
            url += "&TRANSPARENT=true";
            return encodeURI(url).replace(/#/g, encodeURIComponent('#'));
        }
        else if (source$$1 instanceof source.WMTS && source$$1.get('wmsUrl')) {
            var /** @type {?} */ url = source$$1.get('wmsUrl');
            url += "?SERVICE=wms&REQUEST=getMap&VERSION=1.3.0&CRS=" + this.mapStore.getProjection();
            url += "&LAYERS=" + source$$1.getLayer();
            if (source$$1.getStyle().toUpperCase() !== 'DEFAULT') {
                url += "&STYLES=" + (source$$1.getStyle() || '');
            }
            if (this.datestring) {
                url += "&TIME=" + this.datestring;
            }
            url += "&BBOX=" + bounds[0] + "," + bounds[1] + "," + bounds[2] + "," + bounds[3];
            url += "&WIDTH=" + this.width + "&height=" + this.height;
            url += "&FORMAT=image/png";
            url += "&TRANSPARENT=true";
            return url;
        }
        return undefined;
    };
    /**
     * @param {?} config
     * @return {?}
     */
    ThumbnailComponent.prototype.getUrlFromConfig = function (config) {
        var /** @type {?} */ bounds4326 = this.extent;
        var /** @type {?} */ bounds = proj.transformExtent(this.extent, 'EPSG:4326', this.mapStore.getProjection());
        if (config.type === "Mapbox") {
            var /** @type {?} */ mapBoxDimensions = this.getMapboxDimensions(bounds4326, [this.width, this.height]);
            return "" + config.url + config.style + "/static/" + mapBoxDimensions.center[0] + "," + mapBoxDimensions.center[1] + "," + mapBoxDimensions.zoom + "/" + this.width + "x" + this.height + "?access_token=" + config.token;
        }
        else if (config.type === "WMS") {
            var /** @type {?} */ url = config.url;
            url += "?SERVICE=WMS&REQUEST=getMap&VERSION=1.3.0&CRS=" + this.mapStore.getProjection();
            url += "&LAYERS=" + config.layer;
            url += "&STYLES=" + (config.style || '');
            if (this.datestring) {
                url += "&TIME=" + this.datestring;
            }
            if (config.sld_body) {
                url += "&SLD_BODY=" + config.sld_body;
            }
            url += "&BBOX=" + bounds[0] + "," + bounds[1] + "," + bounds[2] + "," + bounds[3];
            url += "&WIDTH=" + this.width + "&HEIGHT=" + this.height;
            url += "&FORMAT=image/png";
            url += "&TRANSPARENT=true";
            return url;
        }
    };
    /**
     * @param {?} extent
     * @param {?} height
     * @param {?} width
     * @return {?}
     */
    ThumbnailComponent.prototype.getThumbnailExtent = function (extent$$1, height, width) {
        var /** @type {?} */ extentCenter = extent.getCenter(extent$$1);
        var /** @type {?} */ extentWidth = Math.abs((extent$$1[2] - extent$$1[0]));
        var /** @type {?} */ extentHeight = Math.abs((extent$$1[3] - extent$$1[1]));
        var /** @type {?} */ extentR = extentWidth / extentHeight;
        var /** @type {?} */ idealR = width / height;
        var /** @type {?} */ idealWidth, /** @type {?} */ idealHeight;
        if (extentR > idealR) {
            idealWidth = extentWidth;
            idealHeight = extentWidth / idealR;
        }
        else {
            idealHeight = extentHeight;
            idealWidth = idealR * extentHeight;
        }
        var /** @type {?} */ x1, /** @type {?} */ y1, /** @type {?} */ x2, /** @type {?} */ y2;
        x1 = extentCenter[0] - (idealWidth / 2);
        y1 = extentCenter[1] - (idealHeight / 2);
        x2 = extentCenter[0] + (idealWidth / 2);
        y2 = extentCenter[1] + (idealHeight / 2);
        return [x1, y1, x2, y2];
    };
    /**
     * @param {?} bounds
     * @param {?} dimensions
     * @return {?}
     */
    ThumbnailComponent.prototype.getMapboxDimensions = function (bounds, dimensions) {
        var /** @type {?} */ minzoom = 0;
        var /** @type {?} */ maxzoom = 20;
        // var merc = fetchMerc(tileSize);
        var /** @type {?} */ base = maxzoom;
        var /** @type {?} */ bl = this.px([bounds[0], bounds[1]], base);
        var /** @type {?} */ tr = this.px([bounds[2], bounds[3]], base);
        var /** @type {?} */ width = tr[0] - bl[0];
        var /** @type {?} */ height = bl[1] - tr[1];
        var /** @type {?} */ ratios = [width / dimensions[0], height / dimensions[1]];
        var /** @type {?} */ center = extent.getCenter(bounds);
        var /** @type {?} */ adjusted = Math.min(base - (Math.log(ratios[0]) / Math.log(2)), base - (Math.log(ratios[1]) / Math.log(2)));
        var /** @type {?} */ zoom = Math.max(minzoom, Math.min(maxzoom, adjusted - 1));
        return { center: center, zoom: zoom };
    };
    /**
     * @param {?} ll
     * @param {?} zoom
     * @return {?}
     */
    ThumbnailComponent.prototype.px = function (ll, zoom) {
        var /** @type {?} */ Bc = [];
        var /** @type {?} */ Cc = [];
        var /** @type {?} */ zc = [];
        var /** @type {?} */ Ac = [];
        var /** @type {?} */ size = 256;
        for (var /** @type {?} */ d_1 = 0; d_1 < 30; d_1++) {
            Bc.push(size / 360);
            Cc.push(size / (2 * Math.PI));
            zc.push(size / 2);
            Ac.push(size);
            size *= 2;
        }
        var /** @type {?} */ D2R = Math.PI / 180;
        var /** @type {?} */ d = zc[zoom];
        var /** @type {?} */ f = Math.min(Math.max(Math.sin(D2R * ll[1]), -0.9999), 0.9999);
        var /** @type {?} */ x = (d + ll[0] * Bc[zoom]);
        var /** @type {?} */ y = (d + 0.5 * Math.log((1 + f) / (1 - f)) * (-Cc[zoom]));
        // (x > Ac[zoom]) && (x = Ac[zoom]);
        // (y > Ac[zoom]) && (y = Ac[zoom]);
        return [x, y];
    };
    /**
     * @return {?}
     */
    ThumbnailComponent.prototype.ngOnDestroy = function () {
        this.urls = undefined;
        this.baseUrl = undefined;
        this.cancelRequests();
    };
    /**
     * @return {?}
     */
    ThumbnailComponent.prototype.cancelRequests = function () {
        this.requests.forEach(function (request) {
            request.unsubscribe();
        });
        this.blobRequests.forEach(function (request) {
            request.unsubscribe();
        });
        this.requests = [];
        this.urls = [];
    };
    return ThumbnailComponent;
}());
ThumbnailComponent.decorators = [
    { type: Component, args: [{
                selector: 'vito-thumbnail',
                template: "<div class=\"tbn-container\" [style.height.px]=\"((urls && urls.length) || baseUrl) ? height : 0\"> <div class=\"tbn-wrap\" [style.width.px]=\"width\"  lazy-load-images> <span class=\"loader {{loadingClass}}\" *ngIf=\"baseUrl && loading.base && !hidden.base\">{{loadingContent}}</span> <img class=\"tbn-image\" *ngIf=\"baseUrl && !hidden.layer[url]\" [src]=\"domSanitizationService.bypassSecurityTrustUrl(baseUrl)\" [style.width]=\"width\" [style.height]=\"height\" [ngStyle]=\"{'opacity': highlighted ? '1' : '0.4'}\" (load)=\"loading.base = false;\" (error)=\"hidden.base = true\"/> <ng-container  *ngFor=\"let url of loadingLayers\"> <span class=\"loader {{loadingClass}}\" *ngIf=\"loading.layer[url] && !hidden.layer[url]\">{{loadingContent}}</span> </ng-container> <ng-container *ngFor=\"let url of urls\"> <img class=\"tbn-image\" *ngIf=\"url && !hidden.layer[url]\" [src]=\"url\" [style.width]=\"width\" [style.height]=\"height\" [ngStyle]=\"{'opacity': highlighted ? '1' : '0.4'}\" (load)=\"loading.layer[url] = false;\" (error)=\"hidden.layer[url] = true\"/> </ng-container> </div> </div> ",
                styles: [".tbn-image { position: absolute; top: 0; left: 0; pointer-events: none; } .tbn-container { height: 150px; width: 100%; } .tbn-wrap { position: relative; height: inherit; } "]
            },] },
];
/**
 * @nocollapse
 */
ThumbnailComponent.ctorParameters = function () { return [
    { type: MapStore, },
    { type: Http, },
    { type: DomSanitizer, },
]; };
ThumbnailComponent.propDecorators = {
    'layers': [{ type: Input },],
    'baseLayer': [{ type: Input },],
    'datestring': [{ type: Input },],
    'width': [{ type: Input },],
    'height': [{ type: Input },],
    'extent': [{ type: Input },],
    'highlighted': [{ type: Input },],
    'loadingClass': [{ type: Input },],
    'loadingContent': [{ type: Input },],
};

// services
var HistorySliderComponent = (function () {
    /**
     * @param {?} mapStore
     * @param {?} mapActions
     */
    function HistorySliderComponent(mapStore, mapActions) {
        this.mapStore = mapStore;
        this.mapActions = mapActions;
        this.dateFormat = "dd-MM-yyyy";
        this.selectedDate = '';
        this.dateChanged = new EventEmitter();
        this.currentPage = 0;
        this.limit = 0;
        this.times = [];
    }
    /**
     * @return {?}
     */
    HistorySliderComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.mapStore.state.subscribe(function (newState) {
            _this._layers = newState.layers;
            if (_this.layers && _this._layers && !_this.times.length) {
                _this.setLayer();
            }
        });
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    HistorySliderComponent.prototype.ngOnChanges = function (changes) {
        if (changes['layers'] && ((!changes['layers'].isFirstChange() && changes['layers'].previousValue.join() !== changes['layers'].currentValue.join()) || !changes['layers'].previousValue)) {
            if (this._layers) {
                this.setLayer();
            }
        }
    };
    /**
     * @return {?}
     */
    HistorySliderComponent.prototype.setLayer = function () {
        var _this = this;
        this._timeLayer = this._layers.find(function (sourceLayer) {
            return sourceLayer.get('id') === _this.layers[0];
        });
        if (this._timeLayer) {
            this.loadTimes();
        }
        else {
            this.times = [];
        }
    };
    /**
     * @return {?}
     */
    HistorySliderComponent.prototype.loadTimes = function () {
        var _this = this;
        this.times = [];
        var /** @type {?} */ times = this._timeLayer.get('vitojs_history');
        if (times) {
            if (times.length > 0) {
                this.times = times.slice();
                var /** @type {?} */ currentTime = void 0;
                if (this._timeLayer.getSource() instanceof source.ImageWMS || this._timeLayer.getSource() instanceof source.TileWMS) {
                    currentTime = ((this._timeLayer.getSource())).getParams()['TIME'];
                }
                else if (this._timeLayer.getSource() instanceof source.WMTS) {
                    currentTime = ((this._timeLayer.getSource())).getDimensions()['TIME'];
                }
                if (this.selectedDate) {
                    var /** @type {?} */ arr = times.slice();
                    var /** @type {?} */ diffdate = new Date(this.selectedDate);
                    if (!times.find(function (date) {
                        return date.string === _this.selectedDate;
                    })) {
                        // FIND CLOSEST DATE
                        this.selectedDate = this._getClosestDate(diffdate, arr);
                        // CHECK FOR CLOSEST DATE IN YEAR
                        if (this.year && Number(this.year) && this.selectedDate.indexOf(this.year.toString()) === -1) {
                            var /** @type {?} */ yearFiltered = arr.filter(function (date) {
                                return Number(date.date.getFullYear()) === Number(_this.year);
                            });
                            if (yearFiltered && yearFiltered.length) {
                                this.selectedDate = this._getClosestDate(diffdate, yearFiltered);
                            }
                        }
                    }
                }
                else if (currentTime && this.selectedDate === '') {
                    this.selectedDate = currentTime;
                }
                else {
                    this.selectedDate = this.times[this.times.length - 1].string;
                }
                this.getPage();
                this.currentPage = Math.floor(this.times.indexOf(this.times.find(function (time) { return time.string === _this.selectedDate; })) / this.limit);
                this.updateShowOnPage();
                if (this.selectedDate) {
                    this.updateTime(this.selectedDate);
                }
            }
        }
        else {
            this.mapActions.addHistory(this._timeLayer);
        }
    };
    /**
     * @return {?}
     */
    HistorySliderComponent.prototype.getPage = function () {
        if (this.slider) {
            var /** @type {?} */ sliderWidth = this.slider.nativeElement.offsetWidth * .80;
            var /** @type {?} */ newLimit = Math.floor(sliderWidth / this.width);
            var /** @type {?} */ lastElem = this.currentPage * this.limit + (this.limit + 1);
            var /** @type {?} */ size = this.times.length - 1;
            if (newLimit !== this.limit) {
                this.currentPage = Math.floor((lastElem < size ? lastElem : size) / newLimit);
                this.updateShowOnPage();
            }
            this.limit = newLimit;
        }
    };
    /**
     * @param {?} date
     * @return {?}
     */
    HistorySliderComponent.prototype.updateTime = function (date) {
        var _this = this;
        this.selectedDate = date;
        this.dateChanged.emit(date);
        this.layers.forEach(function (layerId) {
            _this.mapActions.updateLayerTime(layerId, _this.selectedDate);
        });
    };
    /**
     * @return {?}
     */
    HistorySliderComponent.prototype.nextPage = function () {
        if (this.currentPage < Math.floor((this.times.length - 1) / this.limit)) {
            this.currentPage++;
            this.updateShowOnPage();
        }
    };
    /**
     * @return {?}
     */
    HistorySliderComponent.prototype.previousPage = function () {
        if (this.currentPage > 0) {
            this.currentPage--;
            this.updateShowOnPage();
        }
    };
    /**
     * @return {?}
     */
    HistorySliderComponent.prototype.updateShowOnPage = function () {
        var _this = this;
        this.showOnPage = this.times.map(function (time, index) {
            return _this._showOnPage(index);
        });
    };
    /**
     * @param {?} index
     * @return {?}
     */
    HistorySliderComponent.prototype._showOnPage = function (index) {
        return index >= this.currentPage * this.limit && index <= this.currentPage * this.limit + (this.limit - 1);
    };
    /**
     * @param {?} date
     * @param {?} arr
     * @return {?}
     */
    HistorySliderComponent.prototype._getClosestDate = function (date, arr) {
        arr.sort(function (a, b) {
            var /** @type {?} */ distancea = Math.abs(date.getTime() - a.date.getTime());
            var /** @type {?} */ distanceb = Math.abs(date.getTime() - b.date.getTime());
            return distancea - distanceb; // sort a before b when the distance is smaller
        });
        var /** @type {?} */ beforedates = arr.filter(function (d) {
            return d.date.getTime() - date.getTime() < 0;
        }), /** @type {?} */ afterdates = arr.filter(function (d) {
            return d.date.getTime() - date.getTime() > 0;
        });
        if (beforedates.length && afterdates.length) {
            var /** @type {?} */ distancea = Math.abs(date.getTime() - beforedates[0].date.getTime());
            var /** @type {?} */ distanceb = Math.abs(date.getTime() - afterdates[0].date.getTime());
            if (distancea > distanceb) {
                return afterdates[0].string;
            }
            else {
                return beforedates[0].string;
            }
        }
        else if (beforedates.length) {
            return beforedates[0].string;
        }
        else {
            return afterdates[0].string;
        }
    };
    return HistorySliderComponent;
}());
HistorySliderComponent.decorators = [
    { type: Component, args: [{
                selector: 'vito-history-slider',
                template: "<div class=\"chevron\" (click)=\"previousPage()\"> <span class=\"left\"> <ng-container *ngIf=\"buttonLeft\"><span [class]=\"buttonLeft\"></span></ng-container> <ng-container *ngIf=\"!buttonLeft\">&lt;</ng-container> </span> </div> <div id=\"slider\" class=\"slider\" #slider> <ng-container *ngFor=\"let time of times; let i = index\"> <div class=\"slider-item\" [ngClass]=\"{active: time.string === selectedDate}\" (click)=\"updateTime(time.string)\" *ngIf=\"showOnPage[i]\"> <vito-thumbnail [layers]=\"layers\" [baseLayer]=\"baseLayer\" [datestring]=\"time.string\" [width]=\"width\" [height]=\"height\" [extent]=\"extent\" [highlighted]=\"time.string === selectedDate\" [loadingClass]=\"loadingClass\" [loadingContent]=\"loadingContent\"></vito-thumbnail> <span>{{ time.date | date:dateFormat }}</span> </div> </ng-container> </div> <div class=\"chevron\" (click)=\"nextPage()\"> <span class=\"right\"> <ng-container *ngIf=\"buttonRight\"><span [class]=\"buttonRight\"></span></ng-container> <ng-container *ngIf=\"!buttonRight\">&gt;</ng-container> </span> </div> ",
                styles: [":host { display: flex; align-items: center; width: 100%; } .slider { flex-grow: 1; display: flex; align-items: center; } .slider-item { display: flex; flex-direction: column; align-items: center; }"]
            },] },
];
/**
 * @nocollapse
 */
HistorySliderComponent.ctorParameters = function () { return [
    { type: MapStore, },
    { type: MapActions, },
]; };
HistorySliderComponent.propDecorators = {
    'slider': [{ type: ViewChild, args: ['slider',] },],
    'layers': [{ type: Input },],
    'baseLayer': [{ type: Input },],
    'extent': [{ type: Input },],
    'width': [{ type: Input },],
    'height': [{ type: Input },],
    'dateFormat': [{ type: Input },],
    'selectedDate': [{ type: Input },],
    'loadingClass': [{ type: Input },],
    'loadingContent': [{ type: Input },],
    'year': [{ type: Input },],
    'buttonLeft': [{ type: Input },],
    'buttonRight': [{ type: Input },],
    'dateChanged': [{ type: Output },],
    'getPage': [{ type: HostListener, args: ['window:resize',] },],
};

// services
var HistoryBoxComponent = (function () {
    /**
     * @param {?} mapStore
     * @param {?} mapActions
     */
    function HistoryBoxComponent(mapStore, mapActions) {
        this.mapStore = mapStore;
        this.mapActions = mapActions;
        this.times = [];
    }
    /**
     * @return {?}
     */
    HistoryBoxComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.mapStore.state.subscribe(function (newState) {
            _this._layers = newState.layers;
            if (_this.layers && _this._layers) {
                _this.setLayer();
            }
        });
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    HistoryBoxComponent.prototype.ngOnChanges = function (changes) {
        if (changes['layers'] && (!changes['layers'].isFirstChange() || !changes['layers'].previousValue)) {
            if (this._layers) {
                this.setLayer();
            }
        }
    };
    /**
     * @return {?}
     */
    HistoryBoxComponent.prototype.setLayer = function () {
        var _this = this;
        this._timeLayer = this._layers.find(function (sourceLayer) {
            return sourceLayer.get('id') === _this.layers[0];
        });
        if (this._timeLayer) {
            this.loadTimes();
        }
    };
    /**
     * @return {?}
     */
    HistoryBoxComponent.prototype.loadTimes = function () {
        this.times = [];
        var /** @type {?} */ times = this._timeLayer.get('vitojs_history');
        if (times) {
            if (times.length > 0) {
                this.times = times;
                var /** @type {?} */ currentTime = void 0;
                if (this._timeLayer.getSource() instanceof source.ImageWMS || this._timeLayer.getSource() instanceof source.TileWMS) {
                    currentTime = ((this._timeLayer.getSource())).getParams()['TIME'] || ((this._timeLayer.getSource())).getParams()['time'];
                }
                else if (this._timeLayer.getSource() instanceof source.WMTS) {
                    currentTime = this._timeLayer.getSource().get('TIME');
                }
                if (currentTime) {
                    this.selectedDate = currentTime;
                }
                else {
                    this.selectedDate = this.times[this.times.length - 1].string;
                }
            }
        }
        else {
            this.mapActions.addHistory(this._timeLayer);
        }
    };
    /**
     * @return {?}
     */
    HistoryBoxComponent.prototype.updateTime = function () {
        var _this = this;
        this.layers.forEach(function (layerId) {
            _this.mapActions.updateLayerTime(layerId, _this.selectedDate);
        });
    };
    return HistoryBoxComponent;
}());
HistoryBoxComponent.decorators = [
    { type: Component, args: [{
                selector: 'vito-history-box',
                template: "<select [(ngModel)]=\"selectedDate\"> <option *ngFor=\"let time of times\" [ngValue]=\"time.string\">{{ time.date | date }}</option> </select> <vito-thumbnail *ngIf=\"selectedDate\" [layers]=\"layers\" [baseLayer]=\"baseLayer\" [datestring]=\"selectedDate\" [width]=\"width\" [height]=\"height\" [extent]=\"extent\" highlighted=\"true\"></vito-thumbnail> <button type=\"button\" (click)=\"updateTime()\">Update map</button> "
            },] },
];
/**
 * @nocollapse
 */
HistoryBoxComponent.ctorParameters = function () { return [
    { type: MapStore, },
    { type: MapActions, },
]; };
HistoryBoxComponent.propDecorators = {
    'layers': [{ type: Input },],
    'baseLayer': [{ type: Input },],
    'extent': [{ type: Input },],
    'width': [{ type: Input },],
    'height': [{ type: Input },],
};

var LayerApiService = (function () {
    /**
     * @param {?} http
     */
    function LayerApiService(http) {
        this.http = http;
    }
    /**
     * Retrieves layerdata from ElasticSearch and maps it to layerConfigs
    \@param url the ElasticSearch url (full path)
    \@return An observable with an array of layerconfigs
     * @param {?} url
     * @return {?}
     */
    LayerApiService.prototype.getLayersFromEs = function (url) {
        var _this = this;
        return this.http.get(url).map(function (resp) {
            var /** @type {?} */ data = [];
            resp.json().forEach(function (hit) {
                var /** @type {?} */ config = hit.source;
                var /** @type {?} */ compatibleVersion = '0.0.1';
                var /** @type {?} */ layers = [];
                var /** @type {?} */ queryData = [];
                if (config.version === compatibleVersion) {
                    config.layerList.forEach(function (layerConfig) {
                        var /** @type {?} */ layerSource = {};
                        var /** @type {?} */ type;
                        if (Array.isArray(layerConfig.layerData)) {
                            type = layerConfig.layerData[0].service;
                        }
                        else {
                            type = layerConfig.layerData.service;
                        }
                        switch (type) {
                            case 'WMTS':
                                layerSource = _this.getWmtsSource(layerConfig);
                                break;
                            case 'WMS':
                                layerSource = _this.getWmsSource(layerConfig);
                                break;
                            case 'WFS':
                                layerSource = _this.getWfsSource(layerConfig);
                                break;
                            case 'MVT':
                                layerSource = _this.getMvtSource(layerConfig);
                                break;
                            default:
                                console.error("VitoJS: the layertype is unknown");
                                return;
                        }
                        var /** @type {?} */ parsedLayer = {
                            id: layerConfig.name,
                            name: layerConfig.title,
                            source: layerSource,
                            type: layerConfig.type
                        };
                        if (type === 'MVT') {
                            var /** @type {?} */ scaleVar = void 0;
                            if (Array.isArray(layerConfig.layerData)) {
                                scaleVar = layerConfig.layerData[0].scaleVar;
                            }
                            else {
                                scaleVar = layerConfig.layerData.scaleVar;
                            }
                            if (scaleVar) {
                                parsedLayer.scaleVar = scaleVar;
                            }
                        }
                        layers = layers.concat(parsedLayer);
                        layerConfig.queryData.forEach(function (q) {
                            queryData = queryData.concat({
                                name: q.title,
                                type: layerConfig.type,
                                service: q.service,
                                url: q.url
                            });
                        });
                    });
                    data = data.concat({
                        // id: config.id,
                        id: config.general.title,
                        realId: hit.id,
                        name: config.general.title,
                        bbox: config.general.bbox.split(',').map(function (coord) { return parseFloat(coord); }),
                        layers: layers,
                        data: queryData
                    });
                }
                else {
                    console.error("VitoJS: The api uses another version than this package. Please use version " + compatibleVersion);
                }
            });
            return data;
        });
    };
    /**
     * Returns the source config file for a WMS layer
    \@private
    \@param {*} layerConfig
    \@returns {*}
    \@memberof LayerApiService
     * @param {?} layerConfig
     * @return {?}
     */
    LayerApiService.prototype.getWmsSource = function (layerConfig) {
        var /** @type {?} */ source$$1 = {
            type: 'WMS',
            params: {
                LAYERS: layerConfig.layerData.find(function (element) { return element.service === 'WMS'; }).title,
                STYLES: layerConfig.layerData.find(function (element) { return element.service === 'WMS'; }).style
            }
        };
        if (Array.isArray(layerConfig.layerData)) {
            source$$1.url = layerConfig.layerData.find(function (service) { return service.service === 'WMS'; }).url;
        }
        else {
            source$$1.url = layerConfig.layerData.url;
        }
        return source$$1;
    };
    /**
     * Returns the source config file for a WMTS layer
    \@private
    \@param {*} layerConfig
    \@returns {*}
    \@memberof LayerApiService
     * @param {?} layerConfig
     * @return {?}
     */
    LayerApiService.prototype.getWmtsSource = function (layerConfig) {
        var /** @type {?} */ source$$1 = {
            type: 'WMTS',
            layer: layerConfig.layerData.find(function (element) { return element.service === 'WMTS'; }).title
        };
        if (Array.isArray(layerConfig.layerData)) {
            source$$1.url = layerConfig.layerData.find(function (service) { return service.service === 'WMTS'; }).url;
            var /** @type {?} */ wmsInfo = layerConfig.layerData.find(function (service) { return service.service === 'WMS'; });
            if (wmsInfo) {
                source$$1.wmsUrl = wmsInfo.url;
            }
        }
        else {
            source$$1.url = layerConfig.layerData.url;
        }
        if (layerConfig.style) {
            source$$1.style = layerConfig.style;
        }
        return source$$1;
    };
    /**
     * Returns the source config file for a WFS layer
    \@private
    \@param {*} layerConfig
    \@returns {*}
    \@memberof LayerApiService
     * @param {?} layerConfig
     * @return {?}
     */
    LayerApiService.prototype.getWfsSource = function (layerConfig) {
        var /** @type {?} */ source$$1 = {
            type: 'WFS'
        };
        if (Array.isArray(layerConfig.layerData)) {
            var /** @type {?} */ wfsSource = layerConfig.layerData.find(function (service) { return service.service === 'WFS'; });
            source$$1.url = wfsSource.url;
            source$$1.layer = wfsSource.title;
        }
        else {
            source$$1.url = layerConfig.layerData.url;
            source$$1.layer = layerConfig.layerData.title;
        }
        if (layerConfig.SRS) {
            source$$1.projection = layerConfig.SRS;
        }
        return source$$1;
    };
    /**
     * @param {?} layerConfig
     * @return {?}
     */
    LayerApiService.prototype.getMvtSource = function (layerConfig) {
        var /** @type {?} */ source$$1 = {
            type: 'MVT',
        };
        if (layerConfig.SRS) {
            source$$1.projection = layerConfig.SRS;
        }
        if (Array.isArray(layerConfig.layerData)) {
            source$$1.url = layerConfig.layerData.find(function (service) { return service.service === 'MVT'; }).url;
        }
        else {
            source$$1.url = layerConfig.layerData.url;
        }
        return source$$1;
    };
    return LayerApiService;
}());
LayerApiService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
LayerApiService.ctorParameters = function () { return [
    { type: Http, },
]; };

/**
 * Service for openAm functionality (login, logout, get user info,..).
A proxy with the name /proxy/openam is needed.
\@export
\@class AuthService
 */
var AuthService = (function () {
    /**
     * @param {?} http
     */
    function AuthService(http) {
        this.http = http;
        this.cookieName = 'iPlanetDirectoryPro';
    }
    /**
     * Login to OpenAM service
    \@param {string} realm The openAm realm (usually the application name)
    \@param {string} username The username to log in
    \@param {string} password The password to log in
    \@returns {Observable<string>} When subscribed to it, it logs in and returns the login token
    \@memberof AuthService
     * @param {?} realm
     * @param {?} username
     * @param {?} password
     * @param {?=} domain
     * @return {?}
     */
    AuthService.prototype.authenticate = function (realm, username, password, domain) {
        var _this = this;
        var /** @type {?} */ url;
        if (!!realm) {
            url = "/proxy/openam/json/" + realm + "/authenticate";
        }
        else {
            url = "/proxy/openam/json/authenticate";
        }
        return this.http.post(url, {}, {
            headers: new Headers({
                "X-OpenAM-Username": username,
                "X-OpenAM-Password": password,
                "Content-Type": "application/json"
            })
        }).map(function (res) {
            _this._token = res.json().tokenId;
            Cookie.set(_this.cookieName, _this._token, undefined, '/', domain);
            return _this._token;
        });
    };
    /**
     * Logs the user out trough openAM and removes the cookie.
    \@param {string} cookiename The name of the cookie
    \@returns {Observable<Response>} When subscribed, it logs out and deletes cookie
    \@memberof AuthService
     * @param {?} cookiename
     * @return {?}
     */
    AuthService.prototype.logout = function (cookiename) {
        var _this = this;
        return this.http.post("/proxy/openam/json/sessions/?_action=logout", {})
            .map(function (resp) {
            Cookie.delete(_this.cookieName);
            return resp;
        });
    };
    /**
     * When logged in, this returns the cookie with the authorization token.
    \@returns {*}
    \@memberof AuthService
     * @return {?}
     */
    AuthService.prototype.getAuthToken = function () {
        return _a = {}, _a[this.cookieName] = this._token, _a;
        var _a;
    };
    /**
     * Get user id from token
    \@param {string} token The authorization token
    \@returns {Observable<Response>} Returns user id when subscribed to it
    \@memberof AuthService
     * @param {?} token
     * @return {?}
     */
    AuthService.prototype.getIdentity = function (token) {
        return this.http.post("/proxy/openam/json/users?_action=idFromSession", {});
    };
    /**
     * Get user details from openAM
    \@param {string} realm The openAm realm (usually the application name)
    \@param {string} userName The user id
    \@returns {Observable<Response>} Returns the user details when subscribed to it
    \@memberof AuthService
     * @param {?} realm
     * @param {?} userName
     * @return {?}
     */
    AuthService.prototype.getUser = function (realm, userName) {
        var /** @type {?} */ url;
        if (!!realm) {
            url = "/proxy/openam/json/" + realm + "/users/";
        }
        else {
            url = '/proxy/openam/json/users/';
        }
        return this.http.get(url + userName);
    };
    return AuthService;
}());
AuthService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
AuthService.ctorParameters = function () { return [
    { type: Http, },
]; };

/**
 * Retrieves data from different endpoints (es, timeseries, pep)
and formats it into data ready to inject in a Highcharts chart-object
\@export
\@class ChartDataService
 */
var ChartDataService = (function () {
    /**
     * @param {?} http
     */
    function ChartDataService(http) {
        this.http = http;
    }
    /**
     * Main method to receive the data.
    Calls private methods depending on its endpoint
    \@param {{ name: string, url: string, geoJson?: any, start: Date, end: Date, dataStart?: Date, dataEnd?: Date, endpoint: string, emergenceDate?: Date, cropType?: string }} config Necessary config data
    \@returns {Observable<any>} When subscribed to it, it returns the Highcharts series object.
    \@memberof ChartDataService
     * @param {?} config
     * @return {?}
     */
    ChartDataService.prototype.getData = function (config) {
        switch (config.endpoint) {
            case 'elasticsearch': {
                return this.getEsData(config.name, config.url, config.geoJson, config.start, config.end);
            }
            case 'timeseries': {
                return this.getTimeSeriesData(config.name, config.url, config.geoJson, config.start, config.end);
            }
            case 'timeseries-reference': {
                return this.getTimeSeriesReferenceData(config.name, config.url, config.geoJson, config.start, config.end, config.dataStart, config.dataEnd);
            }
            case 'pep': {
                return this.getPepData(config.name, config.url, config.geoJson, config.start, config.end);
            }
            case 'pep-reference': {
                return this.getPEPReferenceData(config.name, config.url, config.cropType, config.emergenceDate, config.start, config.end);
            }
        }
    };
    /**
     * Retrieves data from Timeseries
    \@private
    \@param {string} name
    \@param {string} url
    \@param {*} geoJson
    \@param {Date} startDate
    \@param {Date} endDate
    \@returns {Observable<any>}
    \@memberof ChartDataService
     * @param {?} name
     * @param {?} url
     * @param {?} geoJson
     * @param {?} startDate
     * @param {?} endDate
     * @return {?}
     */
    ChartDataService.prototype.getTimeSeriesData = function (name, url, geoJson, startDate, endDate) {
        var /** @type {?} */ headers = new Headers();
        headers.append('Content-Type', 'application/json');
        return this.http.post(url + "/geometry", geoJson, {
            params: {
                startDate: this.dateFormatter(startDate),
                endDate: this.dateFormatter(endDate)
            },
            headers: headers
        }).map(function (response) { return response.json().results; })
            .map(function (data) {
            var /** @type {?} */ series = [];
            series.push({
                name: name,
                data: []
            });
            data.forEach(function (datapoint) {
                var /** @type {?} */ idx = 0;
                series[0].data.push([new Date(datapoint.date).getTime(), datapoint.result.average]);
            });
            return series;
        });
    };
    /**
     * Retrieves data for GeometryCollection from Timeseries
    \@private
    \@param {string} name
    \@param {string} url
    \@param {*} geometryCollection
    \@param {Date} startDate
    \@param {Date} endDate
    \@param {Date} dataStart
    \@param {Date} dataEnd
    \@returns {Observable<any>}
    \@memberof ChartDataService
     * @param {?} name
     * @param {?} url
     * @param {?} geometryCollection
     * @param {?} startDate
     * @param {?} endDate
     * @param {?} dataStart
     * @param {?} dataEnd
     * @return {?}
     */
    ChartDataService.prototype.getTimeSeriesReferenceData = function (name, url, geometryCollection, startDate, endDate, dataStart, dataEnd) {
        var _this = this;
        var /** @type {?} */ observables = geometryCollection.geometries.map(function (geoJson) {
            return _this.getTimeSeriesData(name, url, geoJson, dataStart, dataEnd).map(function (result) {
                return result[0];
            });
        });
        return Observable$1.forkJoin(observables)
            .map(function (res) {
            var /** @type {?} */ results = {};
            res.forEach(function (dataset) {
                dataset.data.forEach(function (value, i) {
                    var /** @type {?} */ date = value[0];
                    if (!results[date]) {
                        results[date] = {
                            date: date,
                            values: []
                        };
                    }
                    if ((value[1] === 0 || value[1]) && !isNaN(value[1])) {
                        results[date].values.push(value[1]);
                    }
                });
            });
            var /** @type {?} */ points = chain(results).keys().map(function (date) {
                var /** @type {?} */ values = results[date].values;
                if (values && values.length) {
                    return [results[date].date, mean(values)];
                }
                else {
                    return [results[date].date, NaN];
                }
            }).sortBy(function (value) {
                return value[0];
            }).value();
            if (points.length > 0 && (dataStart !== startDate || dataEnd !== endDate)) {
                var /** @type {?} */ points2 = [];
                var _loop_1 = function (x) {
                    var /** @type {?} */ wy = x;
                    var /** @type {?} */ found = points.find(function (datapoint) {
                        return _this.dateFormatter(new Date(datapoint[0])) === _this.dateFormatter(wy);
                    });
                    points2.push([new Date(_this.dateFormatter(wy, "yyyy-MM-ddT")).getTime(), found ? found[1] : NaN]);
                };
                for (var /** @type {?} */ x = new Date(_this.dateFormatter(startDate, "yyyy-MM-ddT")); x <= new Date(_this.dateFormatter(endDate, "yyyy-MM-ddT")); x.setDate(x.getDate() + 1)) {
                    _loop_1(/** @type {?} */ x);
                }
                points = points2;
            }
            return [{ name: name, data: points }];
        });
    };
    /**
     * Retrieves data from ElasticSearch
    \@private
    \@param {string} name
    \@param {string} url
    \@param {*} geoJson
    \@param {Date} startDate
    \@param {Date} endDate
    \@returns {Observable<any>}
    \@memberof ChartDataService
     * @param {?} name
     * @param {?} url
     * @param {?} geoJson
     * @param {?} startDate
     * @param {?} endDate
     * @return {?}
     */
    ChartDataService.prototype.getEsData = function (name, url, geoJson, startDate, endDate) {
        var /** @type {?} */ headers = new Headers();
        headers.append('Content-Type', 'application/json');
        return this.http.post(url, {
            polygon: geoJson.coordinates[0],
            period: {
                gte: startDate.toISOString(),
                lte: endDate.toISOString()
            }
        }, {
            headers: headers
        }).map(function (response) { return response.json().hits.hits; })
            .map(function (data) {
            var /** @type {?} */ series = [];
            for (var /** @type {?} */ serie in data[0]._source) {
                if (serie !== 'DAY') {
                    series.push({
                        name: name,
                        data: []
                    });
                }
            }
            data.forEach(function (datapoint) {
                var /** @type {?} */ idx = 0;
                for (var /** @type {?} */ serie in datapoint._source) {
                    if (serie !== 'DAY') {
                        series[idx].data.push([new Date(datapoint._source.DAY).getTime(), datapoint._source[serie]]);
                        idx++;
                    }
                }
            });
            return series;
        });
    };
    /**
     * Retrieves data from the pep endpoint
    \@private
    \@param {string} name
    \@param {string} url
    \@param {*} geoJson
    \@param {Date} startDate
    \@param {Date} endDate
    \@returns {Observable<any>}
    \@memberof ChartDataService
     * @param {?} name
     * @param {?} url
     * @param {?} geoJson
     * @param {?} startDate
     * @param {?} endDate
     * @return {?}
     */
    ChartDataService.prototype.getPepData = function (name, url, geoJson, startDate, endDate) {
        var /** @type {?} */ headers = new Headers();
        headers.append('Content-Type', 'application/json');
        var /** @type {?} */ minX = 0;
        var /** @type {?} */ minY = 0;
        var /** @type {?} */ maxX = 0;
        var /** @type {?} */ maxY = 0;
        if (geoJson.type.toUpperCase() === 'MULTIPOLYGON') {
            minX = Math.min.apply(Math, [].concat.apply([], ([].concat.apply([], geoJson.coordinates))).map(function (c) { return c[0]; }));
            minY = Math.min.apply(Math, [].concat.apply([], ([].concat.apply([], geoJson.coordinates))).map(function (c) { return c[1]; }));
            maxX = Math.max.apply(Math, [].concat.apply([], ([].concat.apply([], geoJson.coordinates))).map(function (c) { return c[0]; }));
            maxY = Math.max.apply(Math, [].concat.apply([], ([].concat.apply([], geoJson.coordinates))).map(function (c) { return c[1]; }));
        }
        else {
            var /** @type {?} */ coord = geoJson.coordinates[0];
            minX = Math.min.apply(Math, coord.map(function (c) { return c[0]; }));
            minY = Math.min.apply(Math, coord.map(function (c) { return c[1]; }));
            maxX = Math.max.apply(Math, coord.map(function (c) { return c[0]; }));
            maxY = Math.max.apply(Math, coord.map(function (c) { return c[1]; }));
        }
        return this.http.post(url, {
            minX: minX,
            minY: minY,
            maxX: maxX,
            maxY: maxY,
            range: {
                gte: startDate.toISOString(),
                lte: endDate.toISOString()
            }
        }, {
            headers: headers
        }).map(function (resp) { return resp.json().aggregations.aggregatedTimeSeries.buckets; })
            .map(function (data) {
            var /** @type {?} */ series = [{
                    name: name,
                    data: []
                }];
            data.forEach(function (datapoint) {
                series[0].data.push([datapoint.key, datapoint.aggResult.value]);
            });
            return series;
        });
    };
    /**
     * Retrieves crop reference data from the pep endpoint
    \@private
    \@param {string} name
    \@param {string} url
    \@param {*} cropType
    \@param {Date} emergenceDate
    \@param {Date} startDate
    \@param {Date} endDate
    \@param {boolean} includeStages
    \@returns {Observable<any>}
    \@memberof ChartDataService
     * @param {?} name
     * @param {?} url
     * @param {?} cropType
     * @param {?} emergenceDate
     * @param {?} startDate
     * @param {?} endDate
     * @param {?=} includeStages
     * @return {?}
     */
    ChartDataService.prototype.getPEPReferenceData = function (name, url, cropType, emergenceDate, startDate, endDate, includeStages) {
        var _this = this;
        if (includeStages === void 0) { includeStages = true; }
        return this.http.get(url + "/" + cropType).map(function (response) { return response.json(); })
            .map(function (response) {
            var /** @type {?} */ stages = [];
            if (includeStages) {
                var /** @type {?} */ groupedStages_1 = {};
                response.forEach(function (date) {
                    if (date.STAGES) {
                        date.STAGES.forEach(function (stage) {
                            if (!groupedStages_1[stage.STAGE_NR]) {
                                groupedStages_1[stage.STAGE_NR] = {
                                    BBCH_STAGE: stage.STAGE_NR,
                                    NAME: stage.NAME,
                                    dates: []
                                };
                            }
                            groupedStages_1[stage.STAGE_NR].dates.push(date.DAP);
                        });
                    }
                });
                var /** @type {?} */ keys$$1 = keys(groupedStages_1);
                keys$$1.forEach(function (key) {
                    var /** @type {?} */ data = groupedStages_1[key];
                    var /** @type {?} */ _startDate = _this.getDayOffset(min(data.dates), emergenceDate);
                    var /** @type {?} */ _endDate = _this.getDayOffset(max(data.dates), emergenceDate);
                    stages.push({
                        TIME: [_startDate.getTime(), _endDate.getTime()],
                        BBCH_STAGE: data.BBCH_STAGE,
                        NAME: data.NAME
                    });
                });
            }
            var /** @type {?} */ stage1Day = find(response.data, function (value) {
                return value.BBCH_STAGE === 1;
            });
            var /** @type {?} */ DAPoffset = stage1Day ? stage1Day.DAP : 0;
            var /** @type {?} */ r = response.map(function (value) {
                var /** @type {?} */ d = _this.getDayOffset(value.DAP - DAPoffset, emergenceDate);
                return [new Date(_this.dateFormatter(d, "yyyy-MM-ddT")).getTime(), isNaN(value.BIOPAR) ? NaN : value.BIOPAR];
            });
            var /** @type {?} */ points = r.filter(function (num) {
                return !!num[1];
            });
            if (points.length > 0) {
                var /** @type {?} */ points2 = [];
                var _loop_2 = function (x) {
                    var /** @type {?} */ wy = x;
                    var /** @type {?} */ found = points.find(function (datapoint) {
                        return _this.dateFormatter(new Date(datapoint[0])) === _this.dateFormatter(wy);
                    });
                    points2.push([new Date(_this.dateFormatter(wy, "yyyy-MM-ddT")).getTime(), found ? found[1] : NaN]);
                };
                for (var /** @type {?} */ x = new Date(_this.dateFormatter(startDate, "yyyy-MM-ddT")); x <= new Date(_this.dateFormatter(endDate, "yyyy-MM-ddT")); x.setDate(x.getDate() + 1)) {
                    _loop_2(/** @type {?} */ x);
                }
                points = points2;
            }
            return includeStages ? [{ name: name, data: points, devstages: stages }] : [{ name: name, data: points }];
        });
    };
    /**
     * @param {?} date
     * @param {?=} mode
     * @return {?}
     */
    ChartDataService.prototype.dateFormatter = function (date, mode) {
        if (mode === void 0) { mode = "yyyy-MM-dd"; }
        if (mode === 'yyyy-MM-dd') {
            return date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2);
        }
        else if (mode === 'yyyy-MM-ddT') {
            return date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2) + "T00:00:00.000Z";
        }
        else if (mode === 'ddMMyyyy') {
            return "" + ("0" + date.getDate()).slice(-2) + ("0" + (date.getMonth() + 1)).slice(-2) + date.getFullYear();
        }
    };
    /**
     * @param {?} date
     * @param {?} days
     * @return {?}
     */
    ChartDataService.prototype.addDays = function (date, days) {
        var /** @type {?} */ result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    };
    /**
     * @param {?} day
     * @param {?} plantingDate
     * @return {?}
     */
    ChartDataService.prototype.getDayOffset = function (day, plantingDate) {
        var /** @type {?} */ date = day ? this.addDays(plantingDate, day) : plantingDate;
        var /** @type {?} */ formatted = this.dateFormatter(date, 'yyyy-MM-ddT');
        return new Date(formatted);
    };
    /**
     * @param {?} list
     * @return {?}
     */
    ChartDataService.prototype.flatten = function (list) {
        var _this = this;
        return list.reduce(function (a, b) { return a.concat(Array.isArray(b) ? _this.flatten(b) : b); }, []);
    };
    return ChartDataService;
}());
ChartDataService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
ChartDataService.ctorParameters = function () { return [
    { type: Http, },
]; };

/**
 * Retrieves current location from user, and emits
the GeoJSON features (location point & accuracy circle)
through the location Observable.
\@export
\@class LocationService
 */
var LocationService = (function () {
    function LocationService() {
        this._location = new Subject();
        this.geojson = {
            type: 'Feature',
            geometry: {},
            properties: {}
        };
        this.location = this._location.asObservable();
    }
    /**
     * Start to track the current GPS location.
    \@param {string} projection The projection in which the features are emitted
    \@returns {Observable<any>} The observable which emit the features
    \@memberof LocationService
     * @param {?} projection
     * @return {?}
     */
    LocationService.prototype.startTracking = function (projection) {
        var _this = this;
        this.geoLocation = new Geolocation({
            tracking: true,
            projection: projection
        });
        this.eventKey = this.geoLocation.on('change:accuracyGeometry', function (event) {
            var /** @type {?} */ accGeoJson = Object.assign({}, _this.geojson, {
                geometry: {
                    type: 'Polygon',
                    coordinates: ((_this.geoLocation.getAccuracyGeometry())).getCoordinates(true)
                }
            });
            var /** @type {?} */ posGeoJson = Object.assign({}, _this.geojson, {
                geometry: {
                    type: 'Point',
                    coordinates: _this.geoLocation.getPosition()
                }
            });
            _this._location.next([accGeoJson, posGeoJson]);
        });
        return this.location;
    };
    /**
     * Stop tracking the current GPS location.
    \@memberof LocationService
     * @return {?}
     */
    LocationService.prototype.stopTracking = function () {
        Observable.unByKey(this.eventKey);
        this.geoLocation = undefined;
    };
    return LocationService;
}());
LocationService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
LocationService.ctorParameters = function () { return []; };

// third party libraries
var GeoAnalysisService = (function () {
    function GeoAnalysisService() {
        this.formatter = new format.GeoJSON();
    }
    /**
     * @param {?} geoJson
     * @return {?}
     */
    GeoAnalysisService.prototype.getGeometryCenter = function (geoJson) {
        return extent.getCenter(this.formatter.readFeature(geoJson).getGeometry().getExtent());
    };
    return GeoAnalysisService;
}());
GeoAnalysisService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
GeoAnalysisService.ctorParameters = function () { return []; };

/**
 * A component to quickly create simple login functionality
\@export
\@class LoginComponent
\@property {string} realm The application name
\@property {string} submitLabel The label on the submit button. Default is 'Login'.
\@property {string} usernameLabel The label for the username field. Default is 'Username'.
\@property {string} usernamePlaceholder The placeholder for the username field. Default is 'Username'.
\@property {string} passwordLabel The label for the password field. Default is 'Password'.
\@property {string} passwordPlaceholder The placeholder for the password field. Default is 'Password'.
\@property {EventEmitter<string>} onSuccess Emits the login token when logged in succesfully.
\@implements {OnInit}
 */
var LoginComponent = (function () {
    /**
     * @param {?} authService
     * @param {?} fb
     */
    function LoginComponent(authService, fb) {
        this.authService = authService;
        this.submitLabel = "Login";
        this.usernameLabel = "Username";
        this.usernamePlaceholder = "Username";
        this.passwordLabel = "Password";
        this.passwordPlaceholder = "Password";
        this.onSuccess = new EventEmitter();
        this.loginForm = fb.group({
            'username': ['', Validators.required],
            'password': ['', Validators.required],
        }, { updateOn: 'blur' });
    }
    /**
     * Checks whether a realm is given.
    \@returns
    \@memberof LoginComponent
     * @return {?}
     */
    LoginComponent.prototype.ngOnInit = function () {
        if (!this.realm) {
            console.error('VitoJS: Loginform creation failed. Realm is required for authentication.');
            return null;
        }
    };
    /**
     * When the login form is submitted, it is checked in the authentication service.
    If it's valid, the token gets emitted.
    Else, an error message gets displayed.
    \@param {{ value: { username: string, password: string }, valid: boolean }} {value, valid}
    \@memberof LoginComponent
     * @param {?} __0
     * @return {?}
     */
    LoginComponent.prototype.onSubmit = function (_a) {
        var _this = this;
        var value = _a.value, valid = _a.valid;
        this.error = null;
        if (valid) {
            this.authService.authenticate(this.realm, value.username, value.password).subscribe(function (token) {
                _this.onSuccess.emit(token);
            }, function (error) {
                try {
                    var /** @type {?} */ errorBody = error.json();
                    if (errorBody) {
                        switch (errorBody.message) {
                            case "Authentication Failed!!":
                            case "Invalid Password!!":
                                _this.error = _this.usernameLabel + " or " + _this.passwordLabel + " is incorrect";
                                break;
                        }
                    }
                    if (!_this.error) {
                        _this.error = "Server error";
                    }
                }
                catch (e) {
                    _this.error = "Server error";
                }
            });
        }
    };
    return LoginComponent;
}());
LoginComponent.decorators = [
    { type: Component, args: [{
                selector: 'vito-login',
                template: "<form class=\"form\" [formGroup]=\"loginForm\" (ngSubmit)=\"onSubmit(loginForm)\" novalidate #form=\"ngForm\"> <div class=\"form-group\"> <label for=\"login-username\">{{usernameLabel}}</label> <input id=\"login-username\" name=\"username\" formControlName=\"username\" [placeholder]=\"usernamePlaceholder\" class=\"form-control\"> <div class=\"error\" *ngIf=\"loginForm.get('username').hasError('required') && form.submitted\"> {{usernameLabel}} is required. </div> </div> <div class=\"form-group\"> <label for=\"login-password\">{{passwordLabel}}</label> <input id=\"login-password\" name=\"password\" formControlName=\"password\" type=\"password\" [placeholder]=\"passwordPlaceholder\" class=\"form-control\"> <div class=\"error\" *ngIf=\"loginForm.get('password').hasError('required') && form.submitted\"> {{passwordLabel}} is required. </div> </div> <button type=\"submit\">{{submitLabel}}</button> <div class=\"error\" *ngIf=\"error\"> {{error|json}} </div> </form>"
            },] },
];
/**
 * @nocollapse
 */
LoginComponent.ctorParameters = function () { return [
    { type: AuthService, },
    { type: FormBuilder, decorators: [{ type: Inject, args: [FormBuilder,] },] },
]; };
LoginComponent.propDecorators = {
    'realm': [{ type: Input },],
    'submitLabel': [{ type: Input },],
    'usernameLabel': [{ type: Input },],
    'usernamePlaceholder': [{ type: Input },],
    'passwordLabel': [{ type: Input },],
    'passwordPlaceholder': [{ type: Input },],
    'onSuccess': [{ type: Output },],
};

var VitoJS = (function () {
    function VitoJS() {
    }
    /**
     * @return {?}
     */
    VitoJS.forRoot = function () {
        return {
            ngModule: VitoJS,
            providers: [
                OlMapService,
                OlLayerService,
                OlInteractionService,
                OlStyleService,
                ChartDataService,
                LocationService,
                LayerApiService,
                AuthService,
                CapabilitiesService,
                GeoAnalysisService,
                Dispatcher,
                MapActions,
                MapStore,
                { provide: 'Window', useValue: window },
            ]
        };
    };
    return VitoJS;
}());
VitoJS.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    BrowserModule,
                    FormsModule,
                    ReactiveFormsModule,
                    HttpModule
                ],
                declarations: [
                    MapComponent,
                    LayerComponent,
                    InteractionComponent,
                    ThumbnailComponent,
                    HistorySliderComponent,
                    HistoryBoxComponent,
                    LoginComponent
                ],
                exports: [
                    MapComponent,
                    LayerComponent,
                    InteractionComponent,
                    ThumbnailComponent,
                    HistorySliderComponent,
                    HistoryBoxComponent,
                    LoginComponent
                ],
                providers: [
                    OlMapService,
                    OlLayerService,
                    OlInteractionService,
                    OlStyleService,
                    LayerApiService,
                    AuthService,
                    CapabilitiesService,
                    ChartDataService,
                    LocationService,
                    Dispatcher,
                    MapActions,
                    MapStore,
                    GeoAnalysisService,
                    { provide: 'Window', useValue: window },
                ]
            },] },
];
/**
 * @nocollapse
 */
VitoJS.ctorParameters = function () { return []; };

export { VitoJS, MapComponent, LayerComponent, InteractionComponent, ThumbnailComponent, HistorySliderComponent, HistoryBoxComponent, LayerApiService, AuthService, ChartDataService, OlMapService, LocationService, GeoAnalysisService };



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Angular_wig_cropmap_master/node_modules/vitojs/dist/index.js
// module id = ../../../../vitojs/dist/index.js
// module chunks = vendor